<template>
  <div class="detail-header">
    <commontop v-show="isshow"></commontop>
    <!-- 顶部图片 -->
    <div ref="headerWrap" class="header-wrap">
      <div class="pic">
        <span>
          <img class="myThumb" :src="account.thumb" alt="">
        </span>
        <div class="icon">
          <span class="left-arrow" :class="fixed_box ? 'fixedTop' : ''">
            <img v-show="!fixed_box && active == 0" src="@/assets/img/back2x.png" alt="" style="width: 28px; height: 28px" @click="goBack">
            <img v-show="fixed_box" src="@/assets/img/top_back2x.png" alt="" style="width: 28px; height: 28px" @click="goBack">
          </span>
          <span class="share_btn" :class="fixed_box ? 'fixedTop' : ''">
            <img v-show="!fixed_box && active == 0 && !isInApp" src="@/assets/img/more.png" alt="" style="width: 30px; height: 30px" @click.stop="clicks()">
            <img v-show="fixed_box && !isInApp" src="@/assets/img/morefff.png" alt="" style="width: 30px; height: 30px" @click.stop="clicks()">
            <div style="width: 5px; display: inline-block"></div>
            <img v-show="isInApp&&!fixed_box && active == 0 && isGetInfo" src="@/assets/img/share2x.png" alt="" style="width: 30px; height: 30px" @click="share()">
            <img v-show="isInApp&&fixed_box && isGetInfo" src="@/assets/img/top_share2x.png" alt="" style="width: 30px; height: 30px" @click="share()">
          </span>
        </div>
      </div>
      <!-- tab栏 -->
      <div ref="piediv" class="mytab">
        <div class="mytab_content">
          <p v-for="(item, index) in tab_list" :key="index" :class="{ redBottom: active == item.id }" @click="checkedMyTab(item.id)">
            <span>{{ item.title }}</span>
          </p>
        </div>
      </div>
      <!-- 简介1 -->
      <div v-show="active == 0">
        <div class="class-detail">
          <div ref="heightTop" class="detail-title">
            {{ account.lesson_name }}
          </div>
          <div class="detail-study">
            <span style="margin-right: 6px">
              <img class="student_icon" src="@/assets/img/team.png" alt="">
            </span>
            <span class="study" style="margin-right: 22px; position: relative; bottom: 2px">{{ count.buy_count ? count.buy_count : 0 }} 人学习</span>
            <span style="margin-right: 6px" class="flw">
              <img class="Praise" src="@/assets/img/haoping.png" alt="">
            </span>
            <span class="goods" style="position: relative; bottom: 2px">{{ count.comment_rate ? count.comment_rate : 0 }}% 好评率</span>
          </div>
        </div>

        <!-- 价格 -->
        <div v-if="!is_buy && myPrice > 0" class="origin-price">
          <span class="price">￥<span class="big">{{ myPrice }}</span></span>
        </div>
        
        <!-- btn组件 -->
        <div v-if="!is_buy" class="btn-group" @click="consultTeacher">
          <button v-show="isBtn" class="test_study">申请试学</button>
        </div>
        <div class="border-bgc"></div>
        <!-- 宫格 -->
        <div class="box-container" v-if="service_label_list.length">
          <div v-for="(item,index) in service_label_list" :key="index" class="one_item">
            <img class="img_icon" src="@/assets/info_red_icon.png" alt="">
            <span class="info_text">{{ item.name }}</span>
          </div>
        </div>
        <div v-if="is_xly" class="border-bgc"></div>
        <!-- 分期 -->
        <div v-if="!(code_type && code_type == 1)" class="cell">
          <div v-show="vip_type == 1" class="zhek">
            <p class="zhekTitle">折扣</p>
            <div class="zhekItem">
              <div class="zhekLeft">
                <P v-if="myPrice === 0" class="vipzk">限时免费</P>
                <P v-if="vip_type==1&&is_vip==1" class="vipzk" @click="goPay(1)">vip免费</P>
                <P v-if="vip_type==1&&is_vip == 0&&vip_discount<100&&vip_discount>0" class="vipzk" @click="goPay(1)">vip{{ vip_discount/10 }}折</P>
              </div>
              <div class="zhekRight">
                <div v-if="vip_type == 1&&vip_level!=2" class="upgradeVip" @click="goPay(1)">
                  升级vip
                  <div class="arrowRight">
                    ❯
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="vip_type!=1 && vip_discount<100 && vip_discount>0" class="zhek">
            <p class="zhekTitle">折扣</p>
            <div class="zhekItem">
              <div class="zhekLeft">
                <P v-if="myPrice === 0" class="vipzk">限时免费</P>
                <P v-if="vip_discount>0" class="vipzk" @click="goPay(1)">vip{{ vip_discount/10 }}折</P>
                <!-- <P v-if="vip_type==1&&is_vip == 0&&vip_discount<100&&vip_discount>0&&!is_buy" class="vipzk" @click="goPay(1)"></P> -->
              </div>
              <div class="zhekRight">
                <div v-if="vip_level!=2" class="upgradeVip" @click="goPay(1)">
                  升级vip
                  <div class="arrowRight">
                    ❯
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="myPinTuan > 0 && myPrice !== 0&&vip_type!=1" class="zhek">
            <p class="zhekTitle">折扣</p>
            <div class="zhekItem">
              <P class="vipzk" @click="goPinTuan()">立即拼团</P>
            </div>
          </div>
        </div>
        <!-- 筑龙计划 -->
        <!-- <Zlplan></Zlplan> -->
        <div class="border-bgc"></div>
        <!-- 推荐课程 -->
        <div class="cell">
          <div v-for="(item, index) in recommend" :key="index" class="zhek" @click="goTuiJian(item.url)">
            <p v-if="index === 0" class="zhekTitle">搭配</p>
            <p v-else class="zhekTitle-width"></p>
            <p class="baitTitle">{{ item.lesson_name }}</p>
          </div>
        </div>
        <div class="border-bgc"></div>
        <!-- 问答 -->
        <div class="assess-title" style="margin-bottom:0;">
          <p class="evaluate">问答<span>({{ QaCount ? QaCount : 0 }})</span></p>
        </div>
        <div v-if="QaList&&QaList.length" @click="go_allQa()">
          <div v-for="(item,index) in QaList" :key="index" class="QaDiv">
            <div class="QaDivleft">
              <img onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" :src="item.avatar" alt="">
            </div>
            <div class="QaDivright">
              <p class="qaname">{{ item.username }}</p>
              <p v-show="item.extra" class="qaextra">{{ item.extra }}</p>
              <p class="qacontent" v-html="item.content"></p>
              <p class="qareply">{{ item.count }}条回答</p>
              <p class="qatime">{{ item.create_time }}</p>
            </div>
          </div>
          <p v-if="QaList.length>=3" style="paddingBottom:20px;" class="seeMore">查看更多</p>
        </div>
        <div v-else>
          <div class="nodatas">
            <img src="@/assets/new_kong.png" alt>
            <p v-if="isLogin">暂时还没有相关问答~</p>
            <p v-else>登录查看问答详情~</p>
          </div>
        </div>
        <div class="border-bgc"></div>
        <!-- 评价 -->
        <div class="assess-title">
          <p class="evaluate">评价<span>({{ num ? num : 0 }})</span></p>
          <p class="Praise_rate">好评率<span>{{ count.comment_rate }}%</span></p>
        </div>
        <div class="assess">
          <div v-for="(item, index) in pjlist" v-show="pjlist.length > 0" :key="index" class="assess-msg">
            <div class="nick">
              <div class="nick-img">
                <img :src="item.avatar" onerror="javascript:this.src='https://newoss.zhulong.com/tfs/noavatar_big.gif'" alt>
              </div>
              <div id="nick" class="nick-name">
                <p>
                  <span>{{ item.username }}</span>
                  <span style="color: #999; float: right">{{ sli(item.create_time) }}</span>
                </p>
                <van-rate v-model="item.rank" color="#ffd21e" readonly style="margin-top: 5px" :count="5" size="15" />
                <p v-if="index < 3" id="p" style="padding-top: 5px;fontSize:15px" v-html="item.content.replace(/<img.*?>/g, '')"></p>
                <div v-if="item.reply" class="hfP">
                  <div class="hfPTop">
                    <img src="@/assets/myicon/techer.png" alt="">
                    <span class="teacher">老师:</span>
                  </div>
                  <span class="t_content">
                    {{ item.reply.content }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="num > 2" class="seeMore" @click="checkedMyTab(4)">
            查看更多
          </div>
          <div v-show="pjlist.length <= 0" class="kongzt">
            <img src="@/assets/new_kong.png" alt>
            <p v-if="isLogin">暂无评价~</p>
            <p v-else>登录查看评价~</p>
          </div>
        </div>
      </div>
      <!-- 详情2 -->
      <div v-show="active == 1" ref="main">
        <!--  v-finger:multipoint-start="multipointStartHandler" -->
        <div id="slider" ref="sfimg" v-finger:multipoint-start="multipointStartHandler">
          <p class="lesson-info" v-html="info">{{ info }}</p>
        </div>
      </div>
      <!-- 课表 -->
      <div v-show="active == 2" :class="isShopOpenMiniBox ? 'lesson_box1' : 'lesson_box'">
        <div v-if="(is_buy&&is_praxis && brush_combine_id) || (isInApp)" class="class_box">
          <!-- 错题 -->
          <div v-if="is_buy&&is_praxis && brush_combine_id" class="btns">
            <span class="red_btn_st_ct" @click="goMyWrong">
              <img class="icon_img" src="@/assets/lessonDetail/error_ exercises.png" alt="">
              我的错题
            </span>
          </div>
          <!-- 智能刷题 -->
          <div v-if="is_buy&&is_praxis && brush_combine_id" class="btns">
            <span class="red_btn_st_ct" @click="goExercise">
              <img class="icon_img" src="@/assets/lessonDetail/znst_exercises.png" alt="">
              智能刷题
            </span>
          </div>
          <!-- app 下载 -->
          <div v-if="isInApp" class="btns">
            <span  class="red_btn_st_ct" @click="down_lesson_video">
              <img class="icon_img" src="@/assets/lessonDetail/download_course.png" alt="">
              <span>下载课程</span>
            </span>
          </div>
        </div>
         <!-- 继续学习 -->
        <div v-if="video_url" class="continue_box">
          <!--  v-if="continue_btn" -->
          <div class="btns">
            <span class="study_on" @click="continue_to_learn">
              <span class="video_name">{{next_wk_name}}</span>
              <!-- <img class="jxxx" src="../../assets/img/jxxx.png"> -->
              <span class="red">继续上次学习 ＞</span>
            </span>
          </div>
        </div>
        <!-- 课表，内部区分是否购买 -->
        <div v-loading="tableDataLoading">
          <el-tree class="myTree" :data="catalogue_list" :props="defaultTreeProps" node-key="serial_number" icon-class="el-icon-arrow-right" :default-expanded-keys="defaultExpandKeys" :indent="15" :expand-on-click-node="false" @node-click="handleNodeClick">
            <template slot-scope="{node,data}">
              <!-- 章 -->
              <div v-if="data.courseware_type === 0 || data.courseware_type === 1" class="treeCell" :class="getHasStyle(data)">
                <template v-if="data.status==-1">
                  <div class="treeTitleBox" style="display: flex;">
                    <!-- title -->
                    <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      <span v-if="data.serial_number">{{ data.serial_number }} </span>
                      {{ data.courseware_title }}
                    </span>
                    <span class="toBeupdaded">待更新</span>
                  </div>
                </template>
                <template v-if="data.status==1">
                  <div class="treeTitleBox mainTitleBox">
                    <!-- title -->
                    <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      <span v-if="data.serial_number">{{ data.serial_number }} </span>
                      <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                      {{ data.courseware_title }}
                    </span>
                    <div v-if="data.praxis_num" class="treeDetailRight" @click.stop="go_exexcise(data)">
                      <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">随堂练习</span>
                    </div>
                    <!-- <span v-if="!is_buy && data.is_free === 1" class="redSpan">免费</span> -->
                  </div>
                </template>

              </div>

              <!-- 视频 -->
              <div v-else-if="data.courseware_type === 2" class="treeCell"  :class="getHasStyle(data)">
                <template v-if="data.status==-1">
                  <div class="treeTitleBox" style="display: flex;">
                    <div>
                      <!-- icon -->
                      <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/sp2.png" alt="视频">
                      <img v-else class="typeIcon" src="@/assets/lessonDetail/sp.png" alt="视频">
                      <!-- title -->
                      <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                        <span v-if="data.serial_number">{{ data.serial_number }} </span>
                        <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                        {{ data.courseware_title }}
                      </span>
                    </div>
                    <span class="toBeupdaded">待更新</span>
                  </div>
                </template>
                <template v-if="data.status==1" style="position: relative;">
                  <div class="treeTitleBox">
                    <!-- icon -->
                    <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/sp2.png" alt="视频">
                    <img v-else class="typeIcon" src="@/assets/lessonDetail/sp.png" alt="视频">
                    <!-- title -->
                    <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      <span v-if="data.serial_number">{{ data.serial_number }} </span>
                      <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                      {{ data.courseware_title }}
                    </span>
                    <span v-if="data.important_level==1" class="important">[C]</span>
                    <span v-if="data.important_level==2" class="important">[B]</span>
                    <span v-if="data.important_level==3" class="important">[A]</span>
                    <!-- <span v-if="!is_buy && data.cc_id && data.is_free === 1" class="redSpan">试学</span> -->
                    <span v-if="!is_buy && data.cc_id && data.is_free === 1">
                      <img class="free_img" src="@/assets/lessonDetail/free_course.png" alt="">
                    </span>
                  </div>
                  <div v-if="data.video_duration || data.hd_video_size || data.rate > 0 || data.praxis_num" class="treeDetailBox">
                    <!-- 左侧详情 -->
                    <div class="treeDetailLeft">
                      <div class="study_info">
                        <div class="video_progress">
                          <span class="title_name">进度</span>
                          <div class="controlInfo">
                            <span>{{ data.video_duration }}分钟</span>
                            <el-progress :percentage="data.rate||0" :color="customColors" :show-text="false"></el-progress>
                          </div>
                        </div>
                        <div v-if="data.praxis_num > 0 && (data.accomplish || data.accomplish == 0)" class="video_progress">
                          <span class="title_name">掌握度</span>
                          <div class="controlInfo">
                            <span :style="'color:'+customColorMethod(data.accomplish)">{{ data.accomplish ? data.accomplish : 0 }}%</span>
                            <el-progress :percentage="data.accomplish||0" :color="customColors" :show-text="false"></el-progress>
                          </div>
                        </div>
                      </div>
                      <!-- <span v-if="data.video_duration" class="info1">{{ data.video_duration }}分钟</span> -->
                      <!-- <span v-if="data.hd_video_size" class="info1">{{ data.hd_video_size }}M</span>
                      <span v-if="data.rate > 0" class="info2">已学{{ data.rate }}%</span> -->
                    </div>
                    <!-- 右侧随堂 -->
                    <div v-if="data.praxis_num" class="treeDetailRight" @click.stop="go_exexcise(data)">
                      <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">随堂练习</span>
                    </div>
                  </div>

                  <!-- <img v-if="!is_buy && data.is_free !== 1 && (data.children && data.children.length == 0)" class="suo" src="https://newoss.zhulong.com/forum/202308/23/10/1692758087350860.png" alt=""> -->
                </template>

              </div>

              <!-- 直播 -->
              <div v-else-if="data.courseware_type === 3" class="treeCell"  :class="getHasStyle(data)">
                <template v-if="data.status==-1">
                  <div class="treeTitleBox" style="display: flex;">
                    <div>
                      <!-- icon -->
                      <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/zb2.png" alt="直播">
                      <img v-else class="typeIcon" src="@/assets/lessonDetail/zb.png" alt="直播">
                      <!-- title -->
                      <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                        <span v-if="data.serial_number">{{ data.serial_number }} </span>
                        <span v-if="data.item_typestr">
                          [{{ (data.live_type == 3 && data.cc_id) ? '回放': data.item_typestr }}]
                        </span>
                        {{ data.courseware_title }}
                      </span>
                    </div>
                    <span class="toBeupdaded">待更新</span>
                  </div>
                </template>
                <template v-if="data.status==1" style="position: relative;">
                  <div class="treeTitleBox">
                    <!-- icon -->
                    <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/zb2.png" alt="直播">
                    <img v-else class="typeIcon" src="@/assets/lessonDetail/zb.png" alt="直播">
                    <!-- title -->
                    <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      <span v-if="data.serial_number">{{ data.serial_number }} </span>
                      <span v-if="data.item_typestr">
                        [{{ (data.live_type == 3 && data.cc_id) ? '回放': data.item_typestr }}]
                      </span>
                      {{ data.courseware_title }}
                    </span>
                    <span v-if="data.important_level==1" class="important">[C]</span>
                    <span v-if="data.important_level==2" class="important">[B]</span>
                    <span v-if="data.important_level==3" class="important">[A]</span>
                    <span v-if="!is_buy && data.is_free === 1" class="redSpan">公开</span>
                    <span v-if="data.live_type == 3 && !data.cc_id && data.courseware_id > 0" class="toBeupdaded">待更新</span>
                  </div>
                  <!--  -->
                  <div v-if="(is_xly && class_id) && data.live_time" class="treeDetailBox"  >
                    <!-- 左侧详情 -->
                    <div class="treeDetailLeft">
                      <!-- 直播时间、签到 -->
                      <span class="info1">
                        {{ data.live_time }} |
                        <span v-if="data.is_signed > 0">已签到</span>
                        <span v-else>未签到</span>
                      </span>
                      <!--  -->
                      <!-- <span v-if="!is_xly && data.live_time" class="info1">
                        {{ data.live_time }}
                      </span> -->
                      <span v-if="data.video_duration">
                        |  {{data.video_duration}} 分
                      </span>
                      <!-- 直播状态 -->
                      <span v-if="data.live_type == 2" class="isLiving">
                       | <img src="@/assets/classlist/play.gif">进行中
                      </span>
                      <span v-if="data.live_type == 1" class="liveNoBegin">
                        <!-- <img src="@/assets/classlist/wait.png"> -->
                        |  未开始
                      </span>
                      <span v-if="data.live_type == 3" class="liveNoBegin">
                       | 已结束
                      </span>
                      <!-- <span v-if="data.live_type == 3 && !data.cc_id && data.courseware_id > 0" class="info1">待更新</span> -->
                    </div>
                    <!-- 右侧随堂 -->
                    <div v-if="data.praxis_num" class="treeDetailRight" @click.stop="go_exexcise(data)">
                      <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">随堂练习</span>
                    </div>
                  </div>
                </template>
                <!-- <img v-if="!is_buy && data.is_free !== 1 && (data.children && data.children.length == 0)" class="suo" src="https://newoss.zhulong.com/forum/202308/23/10/1692758087350860.png" alt=""> -->

              </div>

              <!-- 试卷 -->
              <div v-else-if="data.courseware_type === 4" class="treeCell"  :class="getHasStyle(data)">
                <template v-if="data.status==-1">
                  <div class="treeTitleBox" style="display: flex;">
                    <div>
                      <!-- icon -->
                      <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/sj2.png" alt="试卷">
                      <img v-else class="typeIcon" src="@/assets/lessonDetail/sj.png" alt="试卷">
                      <!-- title -->
                      <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                        <span v-if="data.serial_number">{{ data.serial_number }} </span>
                        <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                        {{ data.courseware_title }}
                      </span>
                    </div>
                    <span class="toBeupdaded">待更新</span>
                  </div>
                </template>
                <template v-if="data.status==1" style="position: relative;">
                  <div class="treeTitleBox">
                    <!-- icon -->
                    <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/sj2.png" alt="试卷">
                    <img v-else class="typeIcon" src="@/assets/lessonDetail/sj.png" alt="试卷">
                    <!-- title -->
                    <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      <span v-if="data.serial_number">{{ data.serial_number }} </span>
                      <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                      {{ data.courseware_title }}
                    </span>
                    <span v-if="data.important_level==1" class="important">[C]</span>
                    <span v-if="data.important_level==2" class="important">[B]</span>
                    <span v-if="data.important_level==3" class="important">[A]</span>
                    <!-- <span v-if="!is_buy && data.is_free === 1" class="redSpan">免费</span> -->
                    <span v-if="!is_buy && data.is_free === 1">
                      <img class="free_img" src="@/assets/lessonDetail/free_course.png" alt="">
                    </span>
                  </div>
                  <div class="treeDetailBox reviewTreeDetailBox">
                    <!-- 左侧详情 -->
                    <div v-if="(data.review_time && (data.review_type == 2 || data.review_type == 3)) || data.praxis_num || (data.rate&&data.rate>=-1) " class="treeDetailLeft reviewTreeDetailLeft">
                      <div class="outer_review">
                        <div v-if="data.rate>-1" class="testScore">
                          <span>评测得分</span>
                          <div>
                            <echart-component
                              :id="'chart-' + data.id"
                              :value="data.rate/10"
                              >
                            </echart-component>
                          </div>
                          <div :style="'color:'+customColorMethod(data.rate)">{{data.rate}}%</div>
                        </div>
                        <div v-if="data.rate==-1">
                          您还未评测
                        </div>

                        <div class="review_btn">
                          <div v-if="data.rate>-1" class="treeDetailRight" @click.stop="testpaper(data)">
                            <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">重新评测</span>
                          </div>
                          <div v-if="data.rate==-1" class="treeDetailRight" @click.stop="testpaper(data)">
                            <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">立即评测</span>
                          </div>
                          <!-- 右侧随堂 -->
                          <div v-if="data.praxis_num" class="treeDetailRight" @click.stop="go_exexcise(data)">
                            <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">随堂练习</span>
                          </div>
                        </div>
                      </div>
                      
                      <template v-if="(data.review_time && (data.review_type == 2 || data.review_type == 3)) || data.praxis_num">
                         <span v-if="(is_xly && class_id)" class="info1">{{ data.review_time }}</span>
                         <span v-if="!is_xly" class="info1">{{ data.review_time }}</span>
                      </template>                 
                    </div>
                    
                  </div>
                </template>
                <!-- <img v-if="!is_buy && data.is_free !== 1 && (data.children && data.children.length == 0)" class="suo" src="https://newoss.zhulong.com/forum/202308/23/10/1692758087350860.png" alt=""> -->

              </div>

              <!-- 资料 -->
              <div v-else-if="data.courseware_type === 5" class="treeCell"  :class="getHasStyle(data)">
                <template v-if="data.status==-1">
                  <div class="treeTitleBox" style="display: flex;">
                    <div>
                      <!-- icon -->
                      <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/zl2.png" alt="资料">
                      <img v-else class="typeIcon" src="@/assets/lessonDetail/zl.png" alt="资料">
                      <!-- title -->
                      <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                        <span v-if="data.serial_number">{{ data.serial_number }} </span>
                        <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                        {{ data.courseware_title }}
                      </span>
                    </div>
                    <span class="toBeupdaded">待更新</span>
                  </div>
                </template>
                <template v-if="data.status==1" style="position: relative;">
                  <div class="treeTitleBox">
                    <!-- icon -->
                    <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/zl2.png" alt="资料">
                    <img v-else class="typeIcon" src="@/assets/lessonDetail/zl.png" alt="资料">
                    <!-- title -->
                    <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      <span v-if="data.serial_number">{{ data.serial_number }} </span>
                      <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                      {{ data.courseware_title }}
                    </span>
                    <span v-if="data.important_level==1" class="important">[C]</span>
                    <span v-if="data.important_level==2" class="important">[B]</span>
                    <span v-if="data.important_level==3" class="important">[A]</span>
                    <!-- <span v-if="!is_buy && data.is_free === 1" class="redSpan">免费</span> -->
                    <span v-if="!is_buy && data.is_free === 1">
                      <img class="free_img" src="@/assets/lessonDetail/free_course.png" alt="">
                    </span>
                  </div>
                  <div class="treeDetailBox">
                    <!-- 左侧详情 -->
                    <div class="treeDetailLeft">
                      <span class="info1">资料
                        <span v-if="data.filesize">{{ data.filesize > 0 ? (data.filesize / 1024 / 1024).toFixed(2) : 0 }} M</span>
                      </span>
                    </div>
                    <!-- 右侧随堂 -->
                    <div v-if="data.praxis_num" class="treeDetailRight" @click.stop="go_exexcise(data)">
                      <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">随堂练习</span>
                    </div>
                  </div>
                </template>
                <!-- <img v-if="!is_buy && data.is_free !== 1 && (data.children && data.children.length == 0)" class="suo" src="https://newoss.zhulong.com/forum/202308/23/10/1692758087350860.png" alt=""> -->

              </div>

              <!-- 作业 -->
              <div v-else-if="data.courseware_type === 6" class="treeCell"  :class="getHasStyle(data)">
                <template v-if="data.status==-1">
                  <div class="treeTitleBox" style="display: flex;">
                    <div>
                      <!-- icon -->
                      <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/zy2.png" alt="作业">
                      <img v-else class="typeIcon" src="@/assets/lessonDetail/zy.png" alt="作业">
                      <!-- title -->
                      <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                        <span v-if="data.serial_number">{{ data.serial_number }} </span>
                        <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                        {{ data.courseware_title }}
                      </span>
                    </div>
                    <span class="toBeupdaded">待更新</span>
                  </div>
                </template>
                <template v-if="data.status==1" style="position: relative;">
                  <div class="treeTitleBox">
                    <!-- icon -->
                    <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/lessonDetail/zy2.png" alt="作业">
                    <img v-else class="typeIcon" src="@/assets/lessonDetail/zy.png" alt="作业">
                    <!-- title -->
                    <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      <span v-if="data.serial_number">{{ data.serial_number }} </span>
                      <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                      {{ data.courseware_title }}
                    </span>
                    <span v-if="data.important_level==1" class="important">[C]</span>
                    <span v-if="data.important_level==2" class="important">[B]</span>
                    <span v-if="data.important_level==3" class="important">[A]</span>
                    <!-- <span v-if="!is_buy && data.is_free === 1" class="redSpan">免费</span> -->
                    <span v-if="!is_buy && data.is_free === 1">
                      <img class="free_img" src="@/assets/lessonDetail/free_course.png" alt="">
                    </span>
                  </div>
                  <div class="treeDetailBox">
                    <!-- 左侧详情 -->
                    <div class="treeDetailLeft">
                      <span v-if="data.close_time" class="info1">{{ data.close_time }} {{ data.is_task !=1 ? '已截止' : '截止' }}</span>
                      <span v-else class="info1">暂未布置</span>
                    </div>
                    <!-- 右侧随堂 -->
                    <div v-if="data.praxis_num" class="treeDetailRight" @click.stop="go_exexcise(data)">
                      <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">随堂练习</span>
                    </div>
                  </div>
                </template>
                <!-- <img v-if="!is_buy && data.is_free !== 1 && (data.children && data.children.length == 0)" class="suo" src="https://newoss.zhulong.com/forum/202308/23/10/1692758087350860.png" alt=""> -->

              </div>

              <!-- 教材 -->
              <div v-else-if="data.courseware_type === 7" class="treeCell"  :class="getHasStyle(data)">
                <template v-if="data.status==-1">
                  <div class="treeTitleBox" style="display: flex;">
                    <div>
                      <!-- icon -->
                      <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/schedule/jc2.png" alt="教材">
                      <img v-else class="typeIcon" src="@/assets/schedule/jc.png" alt="教材">
                      <!-- title -->
                      <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                        <span v-if="data.serial_number">{{ data.serial_number }} </span>
                        <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                        {{ data.courseware_title }}
                      </span>
                    </div>
                    <span class="toBeupdaded">待更新</span>
                  </div>
                </template>
                <template v-if="data.status==1" style="position: relative;">
                  <div class="treeTitleBox">
                    <!-- icon -->
                    <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/schedule/jc2.png" alt="教材">
                    <img v-else class="typeIcon" src="@/assets/schedule/jc.png" alt="教材">
                    <!-- title -->
                    <span class="typeTitle typeTitleBlack" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      <span v-if="data.serial_number">{{ data.serial_number }} </span>
                      <span v-if="data.item_typestr">[{{ data.item_typestr }}] </span>
                      {{ data.courseware_title }}
                    </span>
                    <span v-if="data.important_level==1" class="important">[C]</span>
                    <span v-if="data.important_level==2" class="important">[B]</span>
                    <span v-if="data.important_level==3" class="important">[A]</span>
                    <!-- <span v-if="!is_buy && data.is_free === 1" class="redSpan">免费</span> -->
                    <span v-if="!is_buy && data.is_free === 1">
                      <img class="free_img" src="@/assets/lessonDetail/free_course.png" alt="">
                    </span>
                  </div>
                  <div class="treeDetailBox">
                    <!-- 左侧详情 -->
                    <div class="treeDetailLeft">
                      <span class="info1">教材
                        <span v-if="data.size">{{ data.size > 0 ? (data.size / 1024 / 1024).toFixed(2) : 0 }} M</span>
                      </span>
                    </div>
                    <!-- 右侧随堂 -->
                    <div v-if="data.praxis_num" class="treeDetailRight" @click.stop="go_exexcise(data)">
                      <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">随堂练习</span>
                    </div>
                  </div>
                </template>
                <!-- <img v-if="!is_buy && data.is_free !== 1 && (data.children && data.children.length == 0)" class="suo" src="https://newoss.zhulong.com/forum/202308/23/10/1692758087350860.png" alt=""> -->

              </div>

              <!-- 满意度 -->
              <div v-else-if="data.courseware_type === 8" class="treeCell"  :class="getHasStyle(data)">
                <template v-if="data.status==-1">
                  <div class="treeTitleBox" style="display: flex;">
                    <div>
                      <!-- icon -->
                      <!-- <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/schedule/myd2.png" alt="满意度"> -->
                      <img class="typeIcon" src="@/assets/schedule/myd.png" alt="满意度">
                      <!-- title -->
                      <span class="typeTitle typeTitleRed" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                        {{ data.serial_number }} [满意度调查表]
                        <span v-if="data.extend.type == '0'">期中满意度调查</span>
                        <span v-else>期末满意度调查</span>
                      </span>
                    </div>
                    <span class="toBeupdaded">待更新</span>
                  </div>
                </template>
                <template v-if="data.status==1" style="position: relative;">
                  <div class="treeTitleBox">
                    <!-- icon -->
                    <!-- <img v-if="getHasStyle(data).includes('titleColorGray')" class="typeIcon" src="@/assets/schedule/myd2.png" alt="满意度"> -->
                    <img class="typeIcon" src="@/assets/schedule/myd.png" alt="满意度">
                    <!-- title -->
                    <span class="typeTitle typeTitleRed" :style="suo_id == data.id ? 'color:  #ee2e2e;' : ''">
                      {{ data.serial_number }} [满意度调查表]
                      <span v-if="data.extend.type == '0'">期中满意度调查</span>
                      <span v-else>期末满意度调查</span>
                    </span>
                    <span v-if="data.important_level==1" class="important">[C]</span>
                    <span v-if="data.important_level==2" class="important">[B]</span>
                    <span v-if="data.important_level==3" class="important">[A]</span>
                    <!-- <span v-if="!is_buy && data.is_free === 1" class="redSpan">免费</span> -->
                    <span v-if="!is_buy && data.is_free === 1">
                      <img class="free_img" src="@/assets/lessonDetail/free_course.png" alt="">
                    </span>
                  </div>

                  <div class="treeDetailBox">
                    <!-- 左侧详情 -->
                    <div class="treeDetailLeft">
                      <span v-if="data.satis_id > 0" class="info1">已完成</span>
                      <span v-else class="info2">请填写</span>
                    </div>
                    <!-- 右侧随堂 -->
                    <div v-if="data.praxis_num" class="treeDetailRight" @click.stop="go_exexcise(data)">
                      <span :class="getHasStyle(data).includes('titleColorGray')?'exerciseBtnGray':'exerciseBtn'">随堂练习</span>
                    </div>
                  </div>
                </template>
                <!-- <img v-if="!is_buy && data.is_free !== 1 && (data.children && data.children.length == 0)" class="suo" src="https://newoss.zhulong.com/forum/202308/23/10/1692758087350860.png" alt=""> -->

              </div>

            </template>
          </el-tree>
        </div>
        <div class="smwy_btn">
          <div class="pj-text">来说说您对本课程的感受吧~</div>
          <div class="pj-btn1" @click="goComment">我要评价</div>
        </div>
      </div>

      <div v-show="active == 4" style="margin-top: 90px">
        <Assess ref="assClick" @getMsg="get($event)"></Assess>
        <span>
        </span>
        <span>
          <button style="display: none;" class="comment" @click="goComment">我要评价</button>
        </span>
      </div>
      <!-- 立即购买 -->
      <div v-show="active !== 3 && isRes" class="detail-footer">
        <div class="foot-left">
          <div class="left-advice" @click="consultTeacher">
            <img src="@/assets/myicon/ffhf.png" class="iv_sc11" alt>
            <p>咨询老师</p>
          </div>
          <div v-if="is_online" class="right-like" @click="goCollect">
            <img v-if="is_favorite === 1 && isLogin" class="iv_sc" src="@/assets/myicon/red_star.png" alt>
            <img v-else class="iv_sc" src="@/assets/myicon/gray_star.png" alt>
            <div v-if="is_online">
              <p v-show="!is_favorite" class="tv_sc">收藏</p>
              <p v-show="is_favorite" class="tv_sc" :style="isLogin?'color: #f02c2d':''">
                收藏
              </p>
            </div>
          </div>
        </div>
        <div v-if="!is_online && !is_buy" class="footer-right" style="background-color: #b1b1b1; color: #fff;width:50%;">
          <p>已下架</p>
        </div>
        <div v-if=" myPinTuan > 0 && myPrice !== 0" class="footer-right group_work" style="width:25%;" @click="goPay(4)">
          <p>立即拼团</p>
        </div>
        <!-- 限时免费 -->
        <div v-if="(!is_buy) && ((free_type!=3&&(free_type==1||is_free_time>0)) || (free_type==2&&!is_free_time) || (free_type!=3&&freeText))" class="freeTime" :class="free_type==1||free_type==3?'over':''" @click="freeCtrl()">
          <p v-if="free_type!=3&&(free_type==1||is_free_time>0)">免费观看</p>
          <p v-if="free_type==2&&!is_free_time">领取限时免费</p>
          <p v-if="free_type!=3 && freeText" class="free_text">{{ freeText }}</p>
        </div>
        <div v-if="is_online&&!is_buy " class="footer-right" :style="((is_online && !is_buy && vip_type )||(myPinTuan > 0 && myPrice !== 0))||free_type!=0 ? 'width:25%;' : 'width:50%'" @click="goPay(2)">
          <p>立即购买</p>
        </div>
        <div v-if="is_buy && video_url && video_url.length > 0 && active!=4" class="footer-right" style="width: 50%" @click="goPay(3)">
          <p>立即听课</p>
        </div>
        <div v-if="is_buy && active==4" class="footer-right" style="width: 50%" @click="goComment">
          <p>立即评价</p>
        </div>
      </div>
    </div>
    <!-- 试卷弹窗 -->
    <div v-show="isMask" class="mask">
      <div class="maskBox">
        <div class="close">
          <img src="../../assets/img/error@2x.png" alt @click="close">
        </div>
        <div class="title">
          <div class="imgs">
            <img src="../../assets/schedule/sj.png" alt>
          </div>
          <div class="infos">{{ exam_name }}</div>
        </div>
        <div class="testMsg">
          <span class="testItem">
            <span class="redWord">{{ question_count }}</span>道题
          </span>
          <span class="line"></span>
          <span class="testItem">
            <span class="redWord">{{ exam_score ? exam_score : 0 }}</span>满分
          </span>
          <span v-if="duration > 0" class="line"></span>
          <span v-if="duration > 0" class="testItem">
            <span class="redWord">{{ duration }}</span>分钟
          </span>
        </div>
        <div class="btn" :class="false ? 'un_btn' : 'btn'" @click="goReviewinng">
          开始做题
        </div>
      </div>
    </div>
    <!-- 分享弹窗 -->
    <van-popup v-model="showBox" class="popups" position="bottom" :style="{ height: '25%' }">
      <div class="shareTop">
        <p>分享至</p>
      </div>
      <div class="shareImg">
        <div class="shareImgMain">
          <dl @click="toqq()">
            <dt>
              <img class="qq" src="../../static/qq.png" alt>
            </dt>
            <dd>
              <p class="qqMsg">QQ好友</p>
            </dd>
          </dl>
          <dl @click="toqqkj()">
            <dt>
              <img class="qq" src="../../static/qqkj.png" alt>
            </dt>
            <dd>
              <p class="qqMsg">QQ空间</p>
            </dd>
          </dl>
          <dl @click="toweibo()">
            <dt>
              <img class="qq" src="../../static/wb.png" alt>
            </dt>
            <dd>
              <p class="qqMsg">微博</p>
            </dd>
          </dl>
        </div>
      </div>
      <div class="shareFoot">
        <p @click="cancel()">取消</p>
      </div>
    </van-popup>
    <van-popup v-model="strategyShow" position="bottom" :style="{ height: '50%' }">
      <div class="popup_div">
        <div>
          <dl class="popup_dl">
            <dt>
              <img class="popup_img" :src="account.thumb" alt>
            </dt>
            <dd>
              <p v-if="groupon_price_s">￥{{ groupon_price }}</p>
              <p v-else>￥{{ strategy_price }}</p>
            </dd>
          </dl>
        </div>
        <div>
          <p class="p_title">请选择购买课程</p>
        </div>
        <div class="p_span">
          <span v-for="(item, index) in strategyList" :key="index" :class="{ span1: index === mySpanIndex }" @click="addStrategyStr(index,item.id)">{{ item.strategy_name }}</span>
        </div>
        <div class="popup_btn" @click="goBay()">
          确定
        </div>
      </div>
    </van-popup>
    <div v-show="openPopupShow" class="ImgBox" @click="backDetail()">
      <p class="lesson-info" v-html="info">{{ info }}</p>
    </div>
    <!-- 回到顶部 -->
    <div v-show="active==1" class="goTop">
      <img src="../../assets/myicon/gotop.png" alt="" @click="go_top()">
    </div>
    <!-- 领取成功弹窗 -->
    <van-popup v-model="getSuccess" class="successBox">
      <p class="tips2">恭喜你领取成功</p>
      <p class="tips">{{ successText }}</p>
      <p class="tips">免费观看直播跟课程的权限</p>
      <el-button style="width:120px;" round type="danger" @click="getSuccess = false">我知道了</el-button>
    </van-popup>
    <!-- 新分享 弹窗 -->
    <van-popup v-model="shareNewBox" position="bottom" class="share_pop">
      <div class="mid_box">
        <img class="top_icon" src="@/assets/share_logo_icon.png" alt="">
        <p class="titl">我邀请您免费观看“{{ lessonName }}”课程</p>
        <img class="thumb" :src="account.thumb" alt="">
      </div>
      <div class="bot">
        <p class="share_i" @click="shareVipLesson">分享至 <img class="top_icon" src="@/assets/share_wechat_icon.png" alt=""></p>
        <p class="share_i1" @click="shareNewBox = false">取消</p>
      </div>
    </van-popup>

    <!-- 领取免费 弹窗 -->
    <van-popup v-model="getFreeFailed" class="shareBox">
      <img class="iocn1" src="@/assets/poplingdang.png" alt="">
      <p class="title1">温馨提示</p>
      <p class="title2">{{ getFreeFailedText }}</p>
      <img class="close_icon" src="@/assets/share_close_icon.png" alt="" @click="getFreeFailed = false">
    </van-popup>

  </div>
</template>
<script>
import NativeShare from 'nativeshare'
import Assess from '@/components/course/Assess.vue'
import Zlplan from '@/components/course/Zlplan.vue'
import { get_evaluate } from '@/api/course.js'
import commontop from '@/components/common/menu.vue'
import { getLessonDetail, getScheduleByLessonId, getShareLessonFree, getStategyById, QaAll, saveUserLessonFree, getShares, isAddComment } from '@/api/course.js'
import { getNewExamApi } from '@/api/evaluation.js'
import { getCollectLesson } from '@/api/collect.js'
import Vue from 'vue'
import { Toast } from 'vant'
Vue.prototype.$toast = Toast
import tool from '@/utils/tools.js'
import Cookies from 'js-cookie'
import wx from 'weixin-js-sdk'
import WechatState from '@/utils/isWechatState.js'
import EchartComponent from '@/components/EchartComponent.vue'

export default {
  components: {
    Assess,
    Zlplan,
    commontop,
    EchartComponent
  },
  data() {
    return {
      service_label_list: [],
      tableDataLoading: false,
      QaList: [],
      QaCount: '',
      clType: 0,
      openPopupShow: false,
      is_online: true, // 是否下架,默认上架
      is_exam: 0, // 是否显示报考
      is_vip: 0,
      vip_type: 0,
      isRes: false,
      is_xly: 0,
      recommend: [], // 推荐课程
      pjlist: [],
      myshow: false,
      scaleIndex: 1,
      scaleCount: 0,
      isshow: false,
      isBtn: false,
      active: 0,
      tab_list: [
        { title: '简介', id: 0 },
        { title: '详情', id: 1 },
        { title: '课表', id: 2 },
        { title: '评价', id: 4 }
      ],
      activeName: ['1'],
      show: false,
      showBox: false,
      strategyShow: false,
      strategyShow1: null,
      strategyList: [
      ],
      StrategyStr: '',
      y_is_buy: '',
      lesson_id: '', // 课程ID
      url: '', // 试学跳转sms
      account: '', // 简介
      count: {
        student_count: 0,
        comment_rate: 0
      }, // 学习好评率
      shareWxConfig: {},
      product_type: 1,
      payUrl: '',
      isMask: false, // 试卷弹窗
      is_join: false, // 加入学习弹窗
      catalogue_list: [], // 课表
      is_buy: false, // 是否购买
      duration: 0, // 考试时间
      exam_name: 0, // 考试名称
      exam_score: 0, // 考试总分
      pass_score: 0, // 及格分数
      question_count: 0, // 题目数
      info: '', // 详情
      // continue_learn: '', // 继续学习跳转链接
      // continue_btn: false, // 继续学习按钮显示隐藏
      num: 0,
      is_favorite: 0,
      sjId: null,
      paperType: '',
      myPrice: 0,
      myIs_vip: 0,
      vip_discount: 0,
      myVip_type: 0,
      live_count: 0,
      video_count: 0,
      lessonName: '',
      navbarHeight: '',
      scrollTop: '',
      fixed_box: false,
      verClickNum: 1,
      strMap: {},
      clickTimer: null,
      lastClickTime: 0,
      isInApp: false,
      myPinTuan: 0,
      is_praxis: 0, // 是否显示智能刷题
      video_url: '',//继续学习
      next_wk_name:'',//继续学习视频名称
      isGetInfo: false, // 请求成功
      // 销售策略
      ad_banner: [],
      original_price: '', // 原价
      strategy_price: '', // 套餐价
      discount_price: '', // 优惠
      groupon_price: '', // 套餐拼团价
      groupon_price_s: false,
      mySpanIndex: 0,
      biaoList: ['男-惊讶', '男-流泪', '男-害羞', '男-闭嘴', '男-睡', '男-发怒', '男-得意', '男-抓狂', '男-吐', '男-偷笑', '男-困', '男-流汗', '男-咒骂', '男-疑问', '男-嘘', '男-晕', '男-衰', '男-再见', '男-猪头', '男-拥抱', '男-爱心', '男-心碎', '男-强', '男-弱', '男-抠鼻', '男-鼓掌', '男-左哼哼', '男-右哼哼', '男-哈欠', '男-鄙视', '男-委屈', '男-阴险', '男-亲亲', '男-可怜', '男-勾引', '男-NO', '男-OK', '男-爱你', '男-蛋糕', '男-给力', '男-哈哈', '男-大哈哈', '男-蜡烛', '男-礼物', '男-胜利'],
      vip_level: 0,
      class_id: '',
      webSocket: null,
      webSocketOpen: false,
      webSocketArr: [],
      defaultTreeProps: {
        label: 'courseware_title',
        children: 'children'
      },
      defaultExpandKeys: [],
      freeText: '', // 限时免费时间文案
      free_type: '', // 免费课程状态
      free_id: '', // 免费活动id
      free_timer: null, // 限时免费倒计时
      is_free_time: false, // 是否领取限时免费课程
      get_free_timer: null, // 领取免费后倒计时
      getSuccess: false, // 领取成功弹窗
      successText: '', // 领取成功提示信息
      seo_description: '',
      isLogin: false,
      showDialog: false, // 是否需要跳转满意度页面
      code_type: '',
      // 新分享的token
      isShareToken: '',
      shareNewBox: false,
      // 分享领取满了
      getFreeFailed: false,
      getFreeFailedText: '',
      suo_id: '',
      isWechat: WechatState.isWechat,
      isWechatMp: WechatState.isWechatMiniprogram,
      // 是否展示顶部打开小程序的盒子
      isShopOpenMiniBox: false,
      openWithSchemeUrl: '',
      openPagePath: '',
      // 打开小程序的按钮类型：1、微信内 用标签打开  2、h5自定义按钮打开
      openMiniBtnType: 0,
      customColors: [
        {color: '#ee2e2e', percentage: 20},
        {color: '#eb933a', percentage: 40},
        {color: '#f5df4b', percentage: 60},
        {color: '#cee450', percentage: 80},
        {color: '#a0cb6c', percentage: 100}
      ],
      brush_combine_id: '', // source_id
      platform:''
    }
  },
  watch: {
    active(n, o) {
      this.uodateMenuStyles(n)
    }
  },
  created() {
    if (this.$route.hash) {
      if (this.$route.hash.split('=')[1] < 5) {
        this.active = this.$route.hash.split('=')[1]
        console.log(this.active, 'this.activethis.activethis.active')
      } else if (this.$route.hash.split('=')[1] == 5) {
        this.active = 2
        // 显示期末满意度弹窗
        this.showDialog = true
      }
    } else {
      this.active = 0
    }

    this.platform = this.$route.query.platform || ''

    this.lesson_id = this.$route.query.lesson_id || this.$route.params.lesson_id.slice(0, -5)
    const token = this.$route.query.share_token || ''
    if (token && token.length > 0) {
      // 先领取 再请求课程
      this.getFreeLesson(token)
    } else {
      // 请求课程
      this.unitInitFunction()
    }
  },
  beforeDestroy() {
    // 关闭socket
    this.closeSocket()
  },
  mounted() {
    const uid = Cookies.get('uid')
    if (uid) {
      this.isLogin = true
    }
    // console.log(AlloyFinger, 'AlloyFinger')
    // console.log(this.Vue)
    if (tool.isInApp()) {
      this.isInApp = true
    } else {
      this.isInApp = false
    }
    if (this.$route.query.active) {
      this.active = 1
    }
    if (this.$route.query.rate) {
      this.active = 2
    }
    this.$nextTick(() => {
      const _this = this
      window.onscroll = function() {
        // 变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop
        // 变量windowHeight是可视区的高度
        var windowHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        // 变量scrollHeight是滚动条的总高度
        var scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight
        if (_this.$refs.piediv.getBoundingClientRect().top < 0) {
          _this.$refs.piediv.style.position = 'fixed'
          _this.$refs.piediv.style.top = 0
          _this.$refs.piediv.style.left = 0
          _this.$refs.piediv.style.zIndex = 999
          // _this.$refs.heightTop.style.marginTop = '90px'
        }
        if (_this.$refs.heightTop.getBoundingClientRect().top > 70) {
          _this.$refs.piediv.style.position = 'static'
          // _this.$refs.heightTop.style.marginTop = '20px'
        }
        // 滚动条到底部的条件
        // console.log(Math.floor(scrollTop + windowHeight), _this.active)
        if (
          Math.floor(scrollTop + windowHeight) >= scrollHeight - 100 &&
          _this.active == 0
        ) {
          // 到了这个就可以进行业务逻辑加载后台数据了
          console.log('简介到了底部')
          // 触底显示详情
          // if (_this.active < 2) {
          //   setTimeout(() => {
          //     _this.active = 1
          //   }, 1000)
          // }
          // document.getElementsByClassName('myThumb')[0].style.display = 'none'
          _this.fixed_box = true

          console.log(_this.fixed_box)
        }
        if (
          Math.floor(scrollTop + windowHeight) >= scrollHeight - 50 &&
          _this.active == 1 && _this.active < 2
        ) {
          // 到了这个就可以进行业务逻辑加载后台数据了
          console.log('详情到了底部')
          // 触底显示课表
          // setTimeout(() => {
          //   if (Math.floor(scrollTop + windowHeight) >= scrollHeight - 100 && _this.active < 2) {
          //     _this.active = 2
          //   }
          // }, 500)
        }
        if (
          Math.floor(scrollTop + windowHeight) >= scrollHeight - 50 &&
          _this.active == 2 && _this.active < 3
        ) {
          // 到了这个就可以进行业务逻辑加载后台数据了
          console.log('课表到了底部')
          // 触底显示评价
          // setTimeout(() => {
          //   if (Math.floor(scrollTop + windowHeight) >= scrollHeight - 100 && _this.active < 3) {
          //     _this.active = 3
          //   }
          // }, 500)
        }
        if (scrollTop == 0 && _this.active === 0) {
          console.log('触顶了')
          _this.fixed_box = false
        }

        const divHeight = document.getElementsByClassName('myThumb')[0]
        if (_this.$route.query.lesson_id) {
          var strs = window.getComputedStyle(divHeight).height
          if (scrollTop > strs.slice(0, 3)) {
            _this.fixed_box = true
          }
        }
      }
      var that = this
      window.addEventListener('scroll', function() {
        that.navbarHeight = Number(document.querySelector('.pic').offsetHeight) // 吸顶的距离
        this.scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop
        // console.log(this.scrollTop, that.navbarHeight)
        if (
          this.scrollTop > that.navbarHeight ||
          this.active == 1 ||
          this.active == 2 ||
          this.active == 4
        ) {
          that.fixed_box = true
        } else if (this.active == 0) {
          that.fixed_box = false
        }
      })
      // this.continue_learn = localStorage.getItem('continue_learn') || ''
      // var reg = new RegExp('(?<=lesson_id=).*?(?=&)')
      // if (this.continue_learn) {
      //   var local_id = this.continue_learn.match(reg)[0]
      // }

      // var cur_id = this.lesson_id
      // if (local_id == cur_id) {
      //   this.continue_btn = true
      // } else {
      //   this.continue_btn = false
      // }
    })
    // $(function() {
    //   $('div.lesson-info').each(function() {
    //     new RTP.PinchZoom($(this), {})
    //   })
    // })
    // const element = document.querySelector('#slider')
    // new EasyScroller(element, {
    //   scrollingX: true,
    //   scrollingY: true,
    //   zooming: true,
    //   minZoom: 1,
    //   maxZoom: 3.0,
    //   zoomLevel: 1,
    //   bouncing: false,
    //   locking: false
    // })
    // 图片上的咨询
    var btnArr = document.getElementsByClassName('imgbtn')
    setTimeout(() => {
      for (let i = 0; i < btnArr.length; i++) {
        btnArr[i].addEventListener('click', function(e) {
          e.stopPropagation()
          document.getElementsByClassName('left-advice')[0].click()
        })
      }
    }, 4000)
    this.biaoList.forEach((item, index) => {
      if (index < 9) {
        this.strMap[index] = '<img src=' + require('@/assets/lan/0' + (index + 1) + '.gif') + '>'
      } else {
        this.strMap[index] = '<img src=' + require('@/assets/lan/' + (index + 1) + '.gif') + '>'
      }
    })
    // const that = this
    // this.$nextTick(() => {
    //   // 获取放大或缩小的区域DOM
    //   const matrix_box = document.querySelector('.lesson-info')
    //   matrix_box.addEventListener('touchstart', function(event) {
    //     var touches = event.touches
    //     var events = touches[0]
    //     var events2 = touches[1]

    //     // 第一个触摸点的坐标
    //     that.displacement.pageX = events.pageX
    //     that.displacement.pageY = events.pageY

    //     that.displacement.moveable = true

    //     if (events2) {
    //       that.displacement.pageX2 = events2.pageX
    //       that.displacement.pageY2 = events2.pageY
    //     }

    //     that.displacement.originScale = that.displacement.scale || 1
    //   })
    //   document.addEventListener('touchmove', function(event) {
    //     if (!that.displacement.moveable) {
    //       return
    //     }

    //     event.preventDefault()

    //     var touches = event.touches
    //     var events = touches[0]
    //     var events2 = touches[1]
    //     if (events2) {
    //       if (!that.displacement.pageX2) {
    //         that.displacement.pageX2 = events2.pageX
    //       }
    //       if (!that.displacement.pageY2) {
    //         that.displacement.pageY2 = events2.pageY
    //       }

    //       var zoom =
    //     that.getDistance(
    //       {
    //         x: events.pageX,
    //         y: events.pageY
    //       },
    //       {
    //         x: events2.pageX,
    //         y: events2.pageY
    //       }
    //     ) /
    //     that.getDistance(
    //       {
    //         x: that.displacement.pageX,
    //         y: that.displacement.pageY
    //       },
    //       {
    //         x: that.displacement.pageX2,
    //         y: that.displacement.pageY2
    //       }
    //     )

    //       var newScale = that.displacement.originScale * zoom

    //       // 最小缩放比例限制
    //       if (newScale < 0.5) {
    //         newScale = 0.5
    //       }
    //       // 最大缩放比例限制
    //       if (newScale > 2) {
    //         newScale = 2
    //       }

    //       that.displacement.scale = newScale

    //       // 设置旋转元素的基点位置
    //       const touchCenterX = (events.pageX + events2.pageX) / 2
    //       const touchCenterY = (events.pageY + events2.pageY) / 2
    //       matrix_box.style.transformOrigin = `${touchCenterX}px ${touchCenterY}px`

    //       matrix_box.style.transform = 'scale(' + newScale + ')'
    //     }
    //   })
    // })
  },
  methods: {
    // 掌握度字体颜色
    customColorMethod(percentage) {
      if (percentage == 0) {
        return '#999';
      } else if (percentage <= 20) {
        return '#ee2e2e';
      } else if (percentage <= 40) {
        return '#eb933a';
      }  else if (percentage <= 60) {
        return '#f5df4b';
      }  else if (percentage <= 80) {
        return '#cee450';
      }   else if (percentage <= 100) {
        return '#a0cb6c';
      } 
    },
    // 判断最外层标题是否加背景色cellBg  判断课程是否购买
    getHasStyle(data){
      const classList = []
      // 一级菜单加粗
      if(data.level==1){
        classList.push('fontw600')
      }
      // 最外层有children的加背景
      if(data.level==1&&data.children.length>0){
        classList.push('cellBg')
      }
      // 没有children的对齐处理
      if(data.level==1&&!data.children.length){
        classList.push('pdl72')
      }
      if(!this.is_buy && data.is_free !== 1 && (data.children && data.children.length == 0)){
        classList.push('titleColorGray')
      }
      return classList
    },
    // 监听active更新菜单，
    uodateMenuStyles(n) {
      if (n == 4) {
        this.$refs.assClick.onLoad()
      }
      if (n !== 0) {
        // 展示顶部菜单的
        document.getElementsByClassName('myThumb')[0].style.display = 'none'
        document.getElementsByClassName('mytab')[0].style.position = 'fixed'
        if (this.isShopOpenMiniBox) {
          document.getElementsByClassName('mytab')[0].style.top = 0
        } else {
          document.getElementsByClassName('mytab')[0].style.top = 0
        }
        document.getElementsByClassName('mytab')[0].style.left = 0
        document.getElementsByClassName('mytab')[0].style.zIndex = 999
      }
      if (n == 1) {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
        document.getElementsByTagName('body')[0].style.minHeight = '1000px'
        console.log(document.getElementsByTagName('body')[0].style.height)
        document.getElementsByClassName('myThumb')[0].style.display = 'none'
        document.getElementById('slider').style.marginTop = 0
        // if (this.isShopOpenMiniBox) {
        //   document.getElementById('slider').style.marginTop = '90px'
        // } else {
        //   document.getElementById('slider').style.marginTop = '45px'
        // }
      }
      if (n == 2) {
        document.getElementsByTagName('body')[0].style.minHeight = '500px'
      }
      if (n == 4) {
        document.getElementsByTagName('body')[0].style.height = 'auto'
      }
      if (n == 0) {
        document.getElementsByTagName('body')[0].style.height = 'auto'

        document.getElementsByClassName('mytab')[0].style.position = 'static'
        document.getElementsByClassName('myThumb')[0].style.display = 'block'
        this.fixed_box = false
      } else {
        document.getElementsByClassName('myThumb')[0].style.display = 'none'
        this.fixed_box = true
      }
    },
    // 领取免费
    getFreeLesson(token) {
      getShareLessonFree({ lesson_id: this.lesson_id, share_token: token }).then(res => {
        console.log(res)
        this.unitInitFunction()
        if (res.errNo != 0) {
          this.getFreeFailed = true
          this.getFreeFailedText = res.msg || ''
        } else {
          this.getFreeFailed = false
          this.getFreeFailedText = ''
        }
      }).catch(() => {
        this.unitInitFunction()
      })
    },
    // 初始化方法，放一个function里调用
    unitInitFunction() {
      this.getData()
      this.getSchedule()
      this.getpl()
      this.getQa()
    },
    shareFun(method) {
      // console.log()
      // alert('点击触发')
      // 先创建一个实例
      // 如果你需要在微信浏览器中分享，那么你需要设置额外的微信配置
      // 特别提示一下微信分享有一个坑，不要分享安全域名以外的链接(具体见jssdk文档)，否则会导致你配置的文案无效
      // 创建实例应该带参数
      const self = this
      var nativeShare = new NativeShare(
        {
          wechatConfig: {
            appId: '',
            timestamp: '',
            nonceStr: '',
            signature: ''
          },
          // 让你修改的分享的文案同步到标签里，比如title文案会同步到<title>标签中
          // 这样可以让一些不支持分享的浏览器也能修改部分文案，默认都不会同步
          syncDescToTag: false,
          syncIconToTag: false,
          syncTitleToTag: false
        }
      )

      // 你也可以在setConfig方法中设置配置参数
      // nativeShare.setConfig({
      //   wechatConfig: {
      //     appId: '',
      //     timestamp: '',
      //     nonceStr: '',
      //     signature: ''
      //   }
      // })

      // 唤起浏览器原生分享组件(如果在微信中不会唤起，此时call方法只会设置文案。类似setShareData)
      if (navigator.userAgent.search(/MicroMessenger/i) > -1) {
        self.$toast('请点击右上角小圆点进行分享')
      } else {
        try {
          // 设置分享文案
          nativeShare.setShareData({
            icon: self.account.thumb,
            link: window.location.href,
            title: self.account.lesson_name,
            desc: self.seo_description,
            from: '@fa-ge'
          })
          nativeShare.call(method)
          // 如果是分享到微信则需要 nativeShare.call('wechatFriend')
          // 类似的命令下面有介绍
          // alert('支持')
        } catch (err) {
          // 如果不支持，你可以在这里做降级处理
          self.$toast('该浏览器不支持此功能,请您使用浏览器分享功能')
        }
      }
    },
    // 领取限时免费、免费观看
    freeCtrl() {
      if (this.is_free_time > 0) {
        window.open(this.video_url, '_blank')
      } else if (this.free_type == 2) {
        var info = {
          lesson_id: this.lesson_id,
          free_id: this.free_id
        }
        saveUserLessonFree(info).then((res) => {
          if (res.errNo == 0) {
            this.getSuccess = true
            this.successText = res.result
            this.is_free_time = 1
            clearInterval(this.free_timer)
            this.free_timer = null
            this.getData()
          } else {
            this.$toast(res.msg.split('，')[0] + '\n' + res.msg.split('，')[1])
          }
        })
      }
    },
    // 限时免费倒计时
    cutTime(timer) {
      var countdown = timer / 1000// 得到相差的描述
      var d = parseInt(countdown / 60 / 60 / 24)
      // d = d < 10 ? '0' + d : d
      var h = parseInt(countdown / 60 / 60 % 24)
      h = h < 10 ? '0' + h : h
      var m = parseInt(countdown / 60 % 60)
      m = m < 10 ? '0' + m : m
      var s = parseInt(countdown % 60)
      s = s < 10 ? '0' + s : s
      if (d > 0) {
        this.freeText = d + '天 ' + h + ':' + m + ':' + s
      } else {
        this.freeText = h + ':' + m + ':' + s
      }
      // console.log(this.freeText, 'this.freeText1111')
    },
    // 我的错题
    goMyWrong() {
      this.$router.push({
        path: '/errorExercise',
        query: {
          lesson_id: this.lesson_id, 
          source_id: this.brush_combine_id, 
          class_id: this.class_id 
        }
      })
    },
    // 智能刷题
    goExercise() {
      this.$router.push({
        path: '/znst',
        query: {
          lesson_id: this.lesson_id,
          source_id: this.brush_combine_id,
          class_id: this.class_id
        }
      })
    },
    // 统一点击方法
    handleNodeClick(data) {
      console.log(data)
      this.suo_id = data.id
      const item_type = data.courseware_type
      if (item_type === 1) {
        // 章 不做任何处理
      } else {
        if (data.courseware_id == 0 && item_type != 8) {
          return
        }
        if (data.status !== 1) {
          return this.$toast('该标题没有课件')
        }
        // 检测app内是否登录
        if (!this.checkCodetypeAppLogin()) {
          return
        }
        if (!this.is_buy && data.is_free !== 1) {
          return this.$toast('请先购买课程')
        }
        if (item_type === 2) {
          // 视频
          this.go_video(data)
        } else if (item_type === 3) {
          // 直播
          if (data.wk_id != 0) {
            if (data.live_type == 3) {
              this.liveBackVideo(data)
            } else if (data.live_type == 2) {
              this.go_live(data)
            } else if (data.live_type == 0) {
              this.$toast('直播尚未设置')
            } else {
              this.$toast('直播尚未开始')
            }
          } else {
            this.$toast('直播尚未设置')
          }
        }
        if (item_type != 2 && item_type != 3) {
          if (this.is_buy || data.is_free == 1) {
            // 已购买
            if (item_type === 4) {
              // 试卷
              this.testpaper(data)
            } else if (item_type === 5) {
              // 资料
              this.go_zl(data)
            } else if (item_type === 6) {
              // 作业
              const t_url = data.task_url || ''
              if (t_url.length > 0) {
                this.go_zyurl(data)
              }
            } else if (item_type === 7) {
              // 教材
              this.go_jc(data)
            } else if (item_type === 8) {
              // 满意度
              this.go_myd(data)
            }
          } else {
            // 未购买
            this.$toast('请先购买课程')
          }
        }
      }
    },
    // 回到顶部
    go_top() {
      var element = document.getElementById('slider')
      element.scrollTop = 0
    },
    wxShareConfig() {
      var ua = navigator.userAgent.toLowerCase()
      var isWeixin = ua.indexOf('micromessenger') !== -1
      if (isWeixin) {
        this.is_wx = true
      } else {
        this.is_wx = false
      }
      var info = {
        url: window.location.href.split('#')[0]
      }
      getShares(info).then(res => {
        console.log(res)
        const result = res.result ? res.result : {}
        this.shareArr = result.shares ? result.shares : []
        const wxconf = result.wxconf ? result.wxconf : {}
        this.shareWxConfig = wxconf
        this.confiShareWx()
        // 检测打开小程序的链接
        if (!tool.isInApp() && !this.isWechatMp) {
          this.checkOpenMiniprogram(wxconf)
        } else {
          this.openMiniBtnType = 0
          this.openWithSchemeUrl = ''
          this.isShopOpenMiniBox = false
        }
      })
    },
    // 配置微信里分享
    confiShareWx() {
      // config
      const threadUrl = decodeURIComponent(this.shareWxConfig.url) // 解码
      const appid = this.shareWxConfig.appId
      const nonceStr = this.shareWxConfig.nonceStr
      const signature = this.shareWxConfig.signature
      const timestamp = this.shareWxConfig.timestamp
      // 修改debug
      const getUid = Cookies.get('uid')
      var dedebug = false
      if (getUid == '8588314' || getUid == '9510694' || getUid == '7170569' || getUid == '15137145') {
        dedebug = true
      }
      console.log('this.shareWxConfig' + JSON.stringify(this.shareWxConfig))
      wx.config({
        debug: dedebug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appid, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名
        jsApiList: [
          'onMenuShareWeibo', // 分享到腾讯微博接口
          'updateTimelineShareData', // 朋友圈和QQ空间
          'updateAppMessageShareData' // 分享给朋友和QQ
        ]
      })
      // 配置数据
      // 微信分享的数据
      var shareData = {
        imgUrl: this.account.thumb, // 分享显示的缩略图地址
        link: threadUrl, // 分享地址
        desc: '我分享了' + this.account.lesson_name, // 分享描述
        title: this.account.lesson_name, // 分享标题
        success: function() {
          // alert('配置成功')
        },
        fail: function(res) {
          const msg = '配置是被' + JSON.stringify(res)
          // alert(msg)
          console.log('wx配置1：' + msg)
        },
        complete: function() {
          // alert('配置完成')
        },
        trigger: function(res) {
          const msg = 'trigger ' + JSON.stringify(res)
          // alert(msg)
          console.log('wx配置2：' + msg)
        }
      }
      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: [
            'onMenuShareWeibo', // 分享到腾讯微博接口
            'updateTimelineShareData', // 朋友圈和QQ空间
            'updateAppMessageShareData' // 分享给朋友和QQ
          ],
          success: function(res) {
            // alert('checkJsApi:success')
            console.log('wx配置success：' + res)
          }
        })
        wx.updateTimelineShareData(shareData)
        wx.updateAppMessageShareData(shareData)
        wx.onMenuShareWeibo(shareData)
      })
      wx.error(function(res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，
        // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，
        // 对于SPA可以在这里更新签名。
        const msg = '配置失败' + JSON.stringify(res)
        console.log('wx配置error：' + msg)
        // alert(msg)
      })
    },
    // 获取问答
    getQa() {
      var params = {
        page: 1,
        limit: 3,
        lesson_id: this.lesson_id
      }
      var _this = this
      QaAll(params).then(res => {
        var reg = /{([\s\S]*?)}/g
        if (res.errNo === 0) {
          res.result.list.forEach((item) => {
            // console.log(item.content)
            if (item.content) {
              item.content = item.content.replace(reg, function(str) {
                str = str.split('{')[1].split('}')[0]
                var strMap = _this.strMap
                // console.log(str, 'str')
                if (strMap[_this.biaoList.indexOf(str)] === undefined) {
                  return strMap[0]
                } else {
                  return strMap[_this.biaoList.indexOf(str)]
                }
              })
            }
          })
          this.QaList = res.result.list
          this.QaCount = res.result.count
        }
      })
    },
    // 跳转全部问答
    go_allQa() {
      this.$router.push({
        path: '/qaAll',
        query: {
          // is_buy: this.is_buy ? 1 : 0,
          lesson_id: this.lesson_id
        }
      })
    },
    // 返回详情页
    backDetail() {
      this.$refs.headerWrap.style.display = 'block'
      this.openPopupShow = false
      document.getElementsByName('viewport')[0].content = 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
    },
    // 详情大图弹层
    openPopup() {
      this.$refs.headerWrap.style.display = 'none'
      this.openPopupShow = true
      document.getElementsByName('viewport')[0].content = 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=3.0, user-scalable=yes'
    },
    multipointStartHandler() {
      // 一个手指以上触摸屏幕触发
      // this.$refs.sfimg.style.display = 'none'
      this.$refs.headerWrap.style.display = 'none'
      this.openPopupShow = true
      document.getElementsByName('viewport')[0].content = 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=3.0, user-scalable=yes'
    },
    checkedMyTab(index) {
      this.active = index
      var link = this.$router.resolve({
        path: this.$route.path,
        query: {
          lesson_id: this.lesson_id
        }
      })
      // console.log(window.location.href)
      window.location.href = link.href + '#i=' + index
    },
    goTuiJian(url) {
      window.location.href = url
    },
    // 拼团
    goPinTuan() {
      if (this.isToLogin()) {
        this.$router.push({
          path: '/group_work',
          query: {
            lesson_id: this.lesson_id
          }
        })
      }
      if (this.strategyList.length) {
        this.clType = 1
        this.strategyShow = true
        this.groupon_price_s = true
        return false
      }
    },
    goBigImg(e) {
      // console.log(e.target.src, 'eeee')
      // 模拟双击事件
      this.time = new Date().getTime()
      setTimeout(() => {
        if (new Date().getTime() - this.time < 300) {
          console.log('双击事件')
          this.$router.push({
            path: '/lessonInfoBigImg',
            query: {
              info: this.info,
              lesson_id: this.lesson_id,
              imgSrc: e.target.src
            }
          })
        }
      }, 300)
    },
    sli(v) {
      var s = String(v).slice(0, 10)
      return s
    },
    getpl() {
      var params = {
        lesson_id: this.lesson_id,
        limit: 2,
        page: 1
      }
      get_evaluate(params)
        .then((res) => {
          if (res.result.list !== undefined) {
            this.pjlist = res.result.list
            console.log(this.pjlist, '评价列表')
          }
          this.num = res.result.count
        })
        .then(() => {
          // this.send()
        })
    },
    go_zyurl(item) {
      const url = item.task_url || ''
      const title = item.serial_number + ' ' + item.courseware_title
      const filename = item.filename || ''
      const filesize = item.filesize || ''
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          const aurl = encodeURIComponent(url)
          const fileUrls = `fileUrl=${aurl}&title=${title}&filename=${filename}&filesize=${filesize}&lesson_id=${this.lesson_id}`
          window.webkit.messageHandlers.vue_download_zi_liao.postMessage(fileUrls)
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_download_zi_liao',
            url,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        window.open(url)
      }
    },
    goBay() {
      if (this.StrategyStr) {
        if (this.clType == 1) {
          this.$router.push({
            path: '/group_work',
            query: {
              lesson_id: this.lesson_id,
              strategy_id: this.StrategyStr
            }
          })
        } else {
          this.$router.push({
              path:'/shop/pay',
              query:{
                product_type:7,
                product_id:this.StrategyStr,
                fromurl:window.location.href,
                platform:this.platform
              }
            })
          // window.location.href = `https://m.zhulong.com/pay/?product_type=7&product_id=${this.StrategyStr}&fromurl=${window.location.href}`
        }
      }
    },
    // 销售策略
    getStategy() {
      var info = {
        id: this.strategyList[0].id
      }
      getStategyById(info).then((res) => {
        // console.log(res, '销售策略立即购买立即购买')
        this.ad_banner = res.result.list
        this.original_price = res.result.price
        this.strategy_price = res.result.strategy_price
        this.discount_price = res.result.discount_price
        this.groupon_price = res.result.groupon_price
      })
    },
    // 销售策略
    addStrategyStr(index, id) {
      this.mySpanIndex = index
      this.StrategyStr = id
      // console.log(this.StrategyStr)
      console.log(id, '销售策略切换切换')
      if (this.groupon_price_s) {
        getStategyById({ id, groupon_id: 1 }).then((res) => {
          this.ad_banner = res.result.list
          this.original_price = res.result.price
          this.strategy_price = res.result.strategy_price
          this.discount_price = res.result.discount_price
          this.groupon_price = res.result.groupon_price
        })
      } else {
        getStategyById({ id }).then((res) => {
          // console.log(res, '销售策略')
          this.ad_banner = res.result.list
          this.original_price = res.result.price
          this.strategy_price = res.result.strategy_price
          this.discount_price = res.result.discount_price
          this.groupon_price = res.result.groupon_price
        })
      }
    },
    clicks() {
      if (document.getElementsByClassName('more_box')[0].style.display == 'block') {
        // console.log(11111)
        document.getElementsByClassName('more_box')[0].style.display = 'none'
      } else {
        document.getElementsByClassName('more_box')[0].style.display = 'block'
      }
      // if (this.isshow === false) {
      //   this.isshow = true
      // } else {
      //   this.isshow = false
      // }
    },
    //  分享
    toweibo() {
      this.shareFun('weibo')
      // var sharesinastring =
      //   'http://service.weibo.com/share/share.php?title=' +
      //   encodeURIComponent(this.account.lesson_name + window.location.href)
      // window.location.href = sharesinastring // 微博在新页面打开
    },
    toqq() {
      this.shareFun('qq')
      // console.log(this.lesson_name, 'this.lesson_name')
      // var _shareUrl = 'https://connect.qq.com/widget/shareqq/index.html?'
      // _shareUrl += 'url=' + encodeURIComponent(window.location.href)
      // _shareUrl += '&title=' + encodeURIComponent(this.account.lesson_name)
      // _shareUrl += '&pic=' + encodeURIComponent(this.account.thumb)
      // window.location.href = _shareUrl // qq
    },
    toqqkj() {
      this.shareFun('qZone')
      // var sharesinastring =
      //   'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?title=' +
      //   encodeURIComponent(this.account.lesson_name) +
      //   '&desc=' +
      //   encodeURIComponent(this.account.lesson_name) +
      //   '&summary=' +
      //   encodeURIComponent(this.account.lesson_name) +
      //   '&url=' +
      //   encodeURIComponent(window.location.href) +
      //   '&searchPic=true' +
      //   encodeURIComponent(this.account.thumb)
      // window.location.href = sharesinastring // qq空间
    },
    // 关闭分享弹框
    cancel() {
      this.showBox = false
    },
    // 分享
    share() {
      const getUid = Cookies.get('uid')
      var dedebug = false
      if (getUid == '8588314' || getUid == '9510694' || getUid == '30187922' || getUid == '15137145' || getUid == '30257601' || getUid == '11590241') {
        dedebug = true
      }
      if (this.isShareToken.length > 0 && tool.isInApp() && dedebug) {
        // 新分享
        this.shareNewBox = true
        return false
      }
      if (tool.isInApp()) {
        // APP 分享
        var url = document.URL
        url = url.replace('i=4', 'i=0')
        url = encodeURIComponent(url)
        var pic = this.account.thumb ? this.account.thumb : ''
        pic = encodeURIComponent(pic)
        const post = 'title=' + this.lessonName + '&type=2' + '&itemId=' + this.lesson_id + '&url=' + url + '&thumb=' + pic
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_shareAction.postMessage(post)
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_shareAction',
            post,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        // wap 分享
        this.showBox = true
      }
    },
    // 分享vip课程
    shareVipLesson() {
      // APP 分享
      this.shareNewBox = false
      var url = document.URL + '?share_token=' + this.isShareToken
      url = encodeURIComponent(url)
      var path = '/pages/webIndex/webIndex?share=' + url
      // path转码一下
      path = encodeURIComponent(path)
      var pic = this.account.thumb ? this.account.thumb : ''
      pic = encodeURIComponent(pic)
      const title = '我邀请您免费观看“' + this.lessonName + '”课程'
      const post = '?title=' + title + '&url=' + path + '&thumb=' + pic + '&appid=gh_7df350421526&wxtype=1'
      if (tool.isInIosApp()) {
        window.webkit.messageHandlers.vue_shareActionNew.postMessage(post)
      } else {
        window.WebViewJavascriptBridge.callHandler(
          'vue_shareActionNew',
          post,
          function(responseData) {
            // android 返参数接受
          }
        )
      }
    },
    go_myd(v) {
      console.log(v)
      this.$router.push({
        path: '/questionnaire',
        query: {
          lesson_id: v.lesson_id,
          lesson_name: this.lessonName,
          rate: v.extend.type
        }
      })
    },
    get(v) {
      this.num = v
    },
    // 跳转
    goSchedule() {
      this.$router.push('/schedule')
    },
    // 返回
    goBack() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp',
            '课程详情返回',
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        // if (this.$route.query.wdsc) {
        //   window.location.href =
        //     '/index/my_collection'
        // } else {
          this.$router.go(-1)
        // }
      }
    },
    // 跳转购买页面
    goPay(type) {
      if (type === 3) {
        console.log('立即听课')
        if (tool.isInApp()) {
          this.watchVideoNow(this.video_url)
        } else {
          window.location.href = this.video_url
        }
      } else if (type === 4) {
        this.goPinTuan()
      } else {
        if (this.strategyShow1 === true) {
          if (this.strategyShow === true) {
            this.strategyShow = false
          } else {
            this.strategyShow = true
            this.groupon_price_s = false
            this.getStategy()
          }
        } else {
          if (type === 2) {
            var { href } = this.$router.resolve({
              path:'/shop/pay',
              query:{
                product_type:1,
                product_id:this.lesson_id,
                fromurl:window.location.href,
                platform:this.platform
              }
            })
            // window.open(href)
            window.location.href = href
          } else if (type === 1) {
            var { href } = this.$router.resolve({
              path:'/shop/pay',
              query:{
                product_type:3,
                product_id:this.lesson_id,
                fromurl:window.location.href,
                platform:this.platform
              }
            })
            // window.open(href)
            window.location.href = href
          }
        }
      }
    },
    // 立即观看
    watchVideoNow(url) {
      console.log('watch now ' + url)
      if (tool.isInIosApp()) {
        window.webkit.messageHandlers.vue_openVideo.postMessage(url)
      } else {
        const aUrl = url.split('?')[1]
        window.WebViewJavascriptBridge.callHandler(
          'vue_openVideo',
          aUrl,
          function(responseData) {
            // android 返参数接受
          }
        )
      }
    },
    // 弹框
    showPopup() {
      this.show = true
    },
    // 课程详情数据
    getData() {
      const dataInfo = {
        lesson_id: this.lesson_id
      }
      getLessonDetail(dataInfo).then((res) => {
        const data = res.result
        // this.code_type = data.code_type || 0
        data.lesson_info.status === -1
          ? (this.is_online = false)
          : (this.is_online = true)
        this.service_label_list = data.service_label_list || []
        this.is_buy = data.is_buy
        this.y_is_buy = data.is_buy
        this.getQa()
        this.wxShareConfig()
        this.is_exam = data.is_exam
        this.is_vip = data.lesson_info.is_vip
        this.is_xly = data.lesson_info.is_xly
        this.vip_type = data.lesson_info.vip_type
        this.vip_level = data.vip_level
        this.isRes = true
        if (res.result.recommend.length > 0) {
          this.recommend = res.result.recommend
        }
        // 设置title标题
        const seo_obj = res.result.seo || {}
        const my_title = document.getElementsByTagName('title')[0]
        my_title.innerHTML = seo_obj.title || ''
        // 设置关键词
        const my_keys = document.getElementsByName('keywords')[0]
        my_keys.content = seo_obj.keywords || ''

        this.seo_description = seo_obj.description
        this.myshow = true
        this.isBtn = true
        const lesson = res.result
        const strategy = lesson.strategy || []
        if (strategy.length > 0) {
          this.strategyShow1 = true
          this.strategyList = strategy
          this.StrategyStr = strategy[0].id
        } else {
          this.strategyShow1 = false
        }
        this.isGetInfo = true
        // 跳转链接
        this.url = lesson.consult_url
        // console.log(this.url, 'this.url')
        this.is_favorite = lesson.is_favorite
        // 简介
        this.account = lesson.lesson_info
        this.lessonName = lesson.lesson_info.lesson_name
        // 好评率/学习
        this.count = lesson.lesson_count
        // 用户是否购买
        // eslint-disable-next-line
        this.myPrice = lesson.lesson_info.price;
        this.myPinTuan = lesson.is_groupon
        this.is_praxis = lesson.is_praxis
        this.myIs_vip = lesson.lesson_info.myIs_vip
        this.vip_discount = lesson.lesson_info.vip_discount
        this.myVip_type = lesson.lesson_info.vip_type

        // 详情
        this.info = lesson.lesson_info.info
        const share_token = data.share_token || ''
        // socket
        const lessonData = lesson.lesson_info ? lesson.lesson_info : {}
        this.brush_combine_id = lessonData.brush_combine_id || ''
        var is_socket = false
        if (this.checkCanUserSocket()) {
          // 生成socket
          console.log('生成socket')
          this.createSocket()
          // 发消息
          if (this.webSocket) {
            is_socket = true
            console.log('发 socket 消息')
            const dataInfo = {
              title: lessonData.lesson_name ? lessonData.lesson_name : '',
              lesson_id: this.lesson_id ? this.lesson_id : '',
              token: share_token
            }
            this.sendCreateOrderDatas(dataInfo)
          }
        }
        // 有token，且  在app或小程序下
        this.isShareToken = ''
        if ((share_token && share_token.length > 0) && (is_socket || tool.isInApp())) {
          this.isShareToken = share_token
        }
        console.log('isShareToken = ', this.isShareToken)
        // debugger

        this.free_type = data.free.free_type
        this.free_id = data.free.free_id
        console.log(this.free_type, 'this.free_type')
        this.is_free_time = data.free.is_free
        if (this.is_free_time) {
          // 领取免费后 判断是否过期
          if (new Date(data.free.end_time.replace(/-/g, '/')) - new Date() > 0) { // 没有过期
            this.get_free_timer = setInterval(() => {
              var timer = new Date(data.free.end_time.replace(/-/g, '/')) - new Date()
              this.cutTime(timer)
              if (new Date() - new Date(data.free.end_time.replace(/-/g, '/')) >= 0) { // 领取优惠过期
                this.getFun()
                this.is_free_time = 0

                clearInterval(this.get_free_timer)
                this.get_free_timer = null
              }
            })
          } else {
            this.is_free_time = 0
          }
          // clearInterval(this.free_timer)
          // this.free_timer = null
        }
        // 限时免费活动未开始
        if (this.free_type == 1) {
          this.freeText = data.free.date_begin.slice('5').slice(0, data.free.date_begin.slice('5').length - 3) + '开始'
          console.log(this.freeText)
        } else if (this.free_type == 2 && !this.is_free_time) {
          // 活动进行中
          if (new Date(data.free.date_end.replace(/-/g, '/')) - new Date(data.free.date_begin.replace(/-/g, '/')) > 0) { // 结束时间大于开始时间
            if (new Date(data.free.date_end.replace(/-/g, '/')) - new Date() > 0) { // 结束时间大于当前时间
              this.free_timer = setInterval(() => {
                var timer = new Date(data.free.date_end.replace(/-/g, '/')) - new Date()
                this.cutTime(timer)
                if (new Date() - new Date(data.free.date_end.replace(/-/g, '/')) >= 0) { // 当前时间大于结束时间活动结束
                  this.free_type = 3
                  clearInterval(this.free_timer)
                  this.free_timer = null
                }
              }, 1000)
              // console.log(timer, 'pppppppp')
            }
          }
        }
      })
    },
    // 课表
    getSchedule() {
      this.tableDataLoading = true
      var info = {
        lesson_id: this.lesson_id
      }
      getScheduleByLessonId(info).then((res) => {
        // console.log(res, '课表接口')
        const data = res.result || {}
        // this.code_type = data.code_type || 0
        // 班级信息
        const cClass = data.class ? data.class : {}
        this.class_id = cClass.class_id || ''
        // 课表
        const schedule = data.schedule || []
        this.catalogue_list = schedule
        this.tableDataLoading = false
        if (schedule && schedule.length > 0) {
          const first = schedule[0]
          const defKeys = this.recursiveGetSerialNumber(first)
          console.log('defKeys', defKeys)
          this.defaultExpandKeys = defKeys
        }

        // 直播数、视频数
        this.live_count = res.result.live_count ? res.result.live_count : 0
        this.video_count = res.result.video_count ? res.result.video_count : 0
        this.video_url = res.result.video_url || ''
        this.next_wk_name = res.result.next_wk_name
        console.log('zhixingle')
        this.buriedPoint()
        // 如果需要进页面显示期末满意度弹窗
        if (this.showDialog) {
          // 判断是否登录状态
          if (this.isToLogin()) {
            // 判断是否购买
            if (res.result.is_buy) {
              // 查找期末满意度数据
              if (this.FindData(res.result.schedule)) {
                // 跳转
                this.go_myd(this.FindData(res.result.schedule))
              } else {
                this.showDialog = false
              }
            }
          }
        }
      })
    },
    // 递归找到期末满意度数据
    FindData(arr) {
      var obj = null
      arr.map((ele) => {
        if (!(ele.children && ele.children.length)) {
          return
        }
        if (ele.children.length > 0) {
          ele.children.forEach((item) => {
            if (item.courseware_type == 8) {
              if (item.extend.type != 0) {
                obj = item
              }
            }
          })
        }
        if (ele.children.length > 0) {
          this.FindData(ele.children)
        } else {
          return
        }
      })
      return obj
    },
    // 递归获取默认展开的章节
    recursiveGetSerialNumber(item) {
      let num_keys = []
      if (item && item.children && item.children.length > 0) {
        const oneKey = item.serial_number || ''
        if (oneKey && oneKey.length > 0) {
          // 加当前
          num_keys.push(oneKey)
          // 判断当前子集
          item.children.forEach(e1 => {
            const in_keys = this.recursiveGetSerialNumber(e1)
            num_keys = num_keys.concat(in_keys)
          })
        }
      }
      return num_keys
    },

    // 评价
    goComment() {
      // 检测app内是否登录
      if (!this.checkCodetypeAppLogin()) {
        return
      }
      if (this.is_buy) {
        const info = {
          lesson_id: this.lesson_id,
          class_id: this.class_id || 0,
          live_id: 0
        }
        isAddComment(info).then(res => {
          if (res.errNo == 0) {
            this.$router.push({ path: '/comment', query: { lesson_id: this.lesson_id, lesson_name: this.lessonName, class_id: this.class_id }})
          } else if (res.errNo == 99) {
            Toast({
              message: '已经评价，不可再次评价'
            })
          }
        })
      } else {
        Toast({
          message: '请购买课程后参与评价'
        })
      }
    },
    // 收藏
    getCollect() {
      if (this.isLogin) {
        const dataInfo = {
          lesson_id: this.lesson_id
        }
        getCollectLesson(dataInfo).then((res) => {
          // Toast(res.result)
          if (res.errNo == 0) {
            if (res.result == '收藏成功') {
              Toast({
                message: '收藏成功',
                icon: require('@/assets/myicon/fcstarr.png')
              })
            } else {
              Toast({
                message: '已取消收藏',
                icon: require('@/assets/myicon/fcstar.png')
              })
            }
          }

          this.getData()
        })
      } else {
        window.open('/login', '_self')
      }
    },
    goCollect() {
      // 检测app内是否登录
      if (!this.checkCodetypeAppLogin()) {
        return
      }
      this.getCollect()
    },
    // 咨询老师
    consultTeacher() {
      // 检测app内是否登录
      if (!this.checkCodetypeAppLogin()) {
        return
      }
      window.location.href = this.url
    },
    // 重定向到登录
    isToLogin() {
      var url = encodeURIComponent(location.href)
      if (!Cookies.get('uid') || !Cookies.get('username')) {
        window.open(
          `/login?redirect=${url}`,
          '_self'
        )
        return false
      } else {
        return true
      }
    },
    // 直播的回放
    liveBackVideo(item) {
      this.unitVideoPlay(this.lesson_id, item.wk_id)
    },
    // 跳转视频播放
    go_video(item) {
      this.unitVideoPlay(this.lesson_id, item.courseware_id)
    },
    // 统一视频播放：直播回放、视频播放
    unitVideoPlay(lesson_id, wk_id) {
      if (tool.isInApp()) {
        const videoPath = 'lesson_id=' + lesson_id + '&wk_id=' + wk_id
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openVideo.postMessage(videoPath)
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_openVideo',
            videoPath,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        if (this.isToLogin()) {
          this.$router.push({ path: '/play', query: { lesson_id: lesson_id, wk_id: wk_id }})
        }
      }
    },
    // 跳转直播
    go_live(item) {
      // console.log(item)
      if (tool.isInApp()) {
        if (!(item.is_free === 1 || this.is_buy === true)) {
          this.$toast('请先购买课程')
          return
        }
        const livePath = 'lesson_id=' + this.lesson_id + '&live_id=' + item.live_id + '&wk_id=' + item.courseware_id
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openLive.postMessage(livePath)
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_openLive',
            livePath,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        // 这里我没动，有问题不要找我，我只处理app的跳转 🙂
        this.$router.push({
          path: '/live',
          query: {
            lesson_id: this.lesson_id,
            wk_id: item.courseware_id,
            live_id: item.courseware_id
          }
        })
      }
    },
    // 评测
    testpaper(item) {
      if(!(item.is_free == 1 || this.is_buy == true)){
        this.$toast('请先购买课程')
        return
      }
      const review_type = item.review_type || ''
      if (review_type == 2 || review_type == 3) {
        // 判断时间
        if (item.is_review == 1) {
          this.doExamAction(item)
        } else {
          if (item.review_time == '' || !item.review_time) {
            this.$toast('评测时间已过期')
          } else {
            // 先不判断时间
            this.doExamAction(item)
            // var textString = item.review_time.split('至')
            // const start_time = Date.parse(textString[0])
            // const end_time = Date.parse(textString[1])
            // const current_time = new Date().getTime()
            // if (current_time - start_time < 0) {
            //   this.$toast('评测时间未到')
            // } else if (current_time - end_time > 0) {
            //   this.doExamAction(item)
            // }
          }
        }
      } else {
        // 其他类型
        this.doExamAction(item)
      }
    },
    // 做题事件
    doExamAction(item) {
      const url = this.$router.resolve({
        path: '/exerciseReport',
        query: {
          schedule_id: item.id,
          class_id: this.class_id,
          lesson_id: this.lesson_id,
          source_id: item.courseware_id,
          source_type: 2
        }
      })
      window.open(url.href)
    },
    // 随堂练习
    go_exexcise(item) {
      console.log(item, 'item')
      // 检测app内是否登录
      if (!this.checkCodetypeAppLogin()) {
        return
      }
      if (item.status !== 1) {
        return this.$toast('该标题没有课件')
      }
      this.suo_id = item.id
      if (this.is_buy || item.is_free == 1) {
        const url = this.$router.resolve({
          path: '/exerciseReport',
          query: {
            schedule_id: item.id,
            lesson_id: this.lesson_id,
            class_id: this.class_id,
            source_id: item.exam_id,
            source_type: item.exam_define_obj_type
          }
        })
        window.open(url.href)
      } else {
        this.$toast('请先购买课程')
      }
    },
    // 关闭试卷弹窗
    close() {
      this.isMask = false
    },
    // 加入学习
    join() {
      console.log('加入学习')
    },
    // 关闭加入学习弹窗
    close_join() {
      this.is_join = false
    },
    // 开始做题 试卷
    goReviewinng() {
      this.$router.push({
        path: '/exerciseMode',
        query: {
          review_id: this.sjId,
          lesson_id: this.lesson_id,
          obj_type: this.paperType
        }
      })
      console.log('开始做题')
    },
    // 资料跳转
    go_zl(item) {
      const url = item.courseware_url || ''
      const title = item.serial_number + ' ' + item.courseware_title
      const filename = item.filename || ''
      const filesize = item.filesize || ''
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          const aurl = encodeURIComponent(url)
          const fileUrls = `fileUrl=${aurl}&title=${title}&filename=${filename}&filesize=${filesize}&lesson_id=${this.lesson_id}`
          window.webkit.messageHandlers.vue_download_zi_liao.postMessage(fileUrls)
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_download_zi_liao',
            url,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        window.open(url)
      }
    },
    // 下载课程视频
    down_lesson_video() {
      if (this.is_buy) {
        if (tool.isInApp()) {
          const params =
            'lesson_id=' + this.lesson_id + '&lesson_name=' + this.lessonName
          if (tool.isInIosApp()) {
            window.webkit.messageHandlers.vue_lessonDownload.postMessage(
              params
            )
          } else {
            window.WebViewJavascriptBridge.callHandler(
              'vue_lessonDownload',
              params,
              function(responseData) {
                // android 返参数接受
              }
            )
          }
        }
      } else {
        Toast({
          message: '请购买课程'
        })
      }
    },
    // 教材页面跳转
    go_jc(item) {
      console.log(item)
      const url = item.courseware_url || ''
      const title = item.serial_number + ' ' + item.courseware_title
      const filename = item.filename || ''
      const filesize = item.filesize || ''
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          const aurl = encodeURIComponent(url)
          const fileUrls = `fileUrl=${aurl}&title=${title}&filename=${filename}&filesize=${filesize}&lesson_id=${this.lesson_id}`
          window.webkit.messageHandlers.vue_download_zi_liao.postMessage(fileUrls)
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_download_zi_liao',
            url,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        window.open(url)
      }
    },
    changeTabs(name, title) {
      // console.log(name, title)
      if (name !== 0) {
        if (document.getElementsByClassName('myThumb')[0]) {
          document.getElementsByClassName('myThumb')[0].style.display = 'none'
          this.fixed_box = true
          // console.log(this.fixed_box)
        }
      } else if (name == 0) {
        // console.log(123456)
        this.fixed_box = false
        document.getElementsByClassName('myThumb')[0].style.display = 'block'
      }
    },
    // 课表申请试学
    try_to_learn() {
      location.href = this.url
    },
    // 继续学习
    continue_to_learn() {
      location.href = this.video_url
    },

    // 检测是否可以开启socket
    checkCanUserSocket() {
      if (typeof WebSocket === 'undefined') {
        return false
      }
      const uid = Cookies.get('uid')
      console.log('22222', uid)
      if (uid === undefined) {
        return false
      }
      const app_code = Cookies.get('mini_p_code')
      console.log('333', app_code)
      if (this.isWechatMp && app_code) {
        return true
      }
      return false
    },
    // 开启socket
    createSocket() {
      this.webSocketArr = []
      this.webSocket = new WebSocket('wss://m.zhulong.com/wss_socket/')
      this.webSocket.onopen = this.webSocketOnOpen
      this.webSocket.onmessage = this.webSocketGetMessage
      this.webSocket.onerror = this.webSocketOnError
      this.webSocket.onclose = this.webSocketClosed
    },
    // 链接
    webSocketOnOpen(res) {
      console.log('open ', res)
      // 登录
      const loginStr = this.createForSocketMessage('login', null)
      console.log('loginStr ', loginStr)
      this.socketSendDatas(loginStr)
      this.webSocketOpen = true
    },
    // 收到消息
    webSocketGetMessage(res) {
      const message = JSON.parse(res.data)
      console.log('收到消息 ', message)
      switch (message.type) {
        case 'login_end':
          console.log('登录成功')
          this.socketLoginSuccess()
          break
        default:
          break
      }
    },
    // 登录成功
    socketLoginSuccess() {
      if (this.webSocketArr.length > 0) {
        this.webSocketArr.forEach(msg => {
          this.socketSendDatas(msg)
        })
      }
      this.webSocketArr = []
    },
    // 失败
    webSocketOnError(res) {
      console.log('失败 ', res)
      this.createSocket()
    },
    // 关闭
    webSocketClosed(res) {
      console.log('关闭 ', res)
      if (res.code != 1000) {
        // 非正常关闭
        this.createSocket()
      }
    },
    // 发消息
    socketSendDatas(jsonInfo) {
      this.webSocket.send(jsonInfo)
    },
    // 关闭socket
    closeSocket() {
      this.webSocket.close()
      this.webSocket = null
    },
    // 获取登录的字符串,info：object
    createForSocketMessage(type, info) {
      const uid = Cookies.get('uid')
      const appid = Cookies.get('app_id')
      const agency_id = Cookies.get('agency_id')
      const uidStr = agency_id + '_' + appid + '_' + uid + '_2'
      var login = {
        type: type,
        uid: uidStr
      }
      // 自定义数据
      if (info) {
        login.data = JSON.stringify(info)
      }
      return JSON.stringify(login)
    },
    // 发下单
    sendCreateOrderDatas(query) {
      console.log(query)
      // 区分哪个小程序
      const app_code = Cookies.get('mini_p_code')
      const order = {
        type: 'mini_lessonDetailTitle',
        app_code: app_code,
        paydata: JSON.stringify(query)
      }
      var infoStr = this.createForSocketMessage('proxy', order)
      console.log(infoStr)
      if (this.webSocketOpen) {
        this.socketSendDatas(infoStr)
      } else {
        this.webSocketArr.push(infoStr)
      }
    },
    // 课程详情页埋点
    buriedPoint() {
      var lesson_id = this.lesson_id
      __ZL__._tracker('lessonView', { 'lesson_id': lesson_id })
    },
    // 检测是否登录
    checkCodetypeAppLogin() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          // if (this.code_type == 1 && !this.isLogin) {
          if (!this.isLogin) {
            window.webkit.messageHandlers.vue_showAppLogin.postMessage('')
            return false
          }
        }
      }
      return true
    },
    // 检测打开小程序的链接
    checkOpenMiniprogram(data) {
      const pagepath = 'pages/webIndex/webIndex' // pages前不要/
      const open_url = window.location.origin + '/edu/d/' + this.lesson_id + '.html#i=' + (this.is_buy ? '2' : '0')
      if (this.isWechat) {
        if (this.isWechatMp) {
          // 小程序内，暂不处理
          this.openMiniBtnType = 0
          this.openWithSchemeUrl = ''
          this.isShopOpenMiniBox = false
        } else {
          var ua = window.navigator.userAgent.toLowerCase()
          if (ua.match(/wxwork/i) == 'wxwork') {
            // 企微 不支持
            this.openMiniBtnType = 3
            this.openWithSchemeUrl = ''
            this.isShopOpenMiniBox = true
            this.uodateMenuStyles(this.active)
          } else {
            // 微信 h5 打开小程序
            this.openMiniBtnType = 1
            this.openPagePath = pagepath + '?share=' + open_url
            this.isShopOpenMiniBox = true
            this.uodateMenuStyles(this.active)
            this.openMiniConfigNext(data)
          }
        }
      } else {
        // h5
        const appid = 'wx828b87bfa158b387'
        const query = 'share=' + open_url
        const scheme = `weixin://dl/business/?appid=${appid}&path=${pagepath}&query=${query}&env_version=release`
        this.openMiniBtnType = 2
        this.openWithSchemeUrl = scheme
        this.isShopOpenMiniBox = true
        this.uodateMenuStyles(this.active)
      }
    },
    openMiniConfigNext(data) {
      const wx = this.$wx
      // const _this = this
      wx.config({
        appId: data.appId,
        // 必填，生成签名的时间戳
        timestamp: data.timestamp,
        // 必填，生成签名的随机串
        nonceStr: data.nonceStr,
        // 必填，签名
        signature: data.signature,
        // 必填，需要使用的JS接口列表，且任意填写
        jsApiList: ['scanQRCode'],
        // 可选，需要使用的开放标签列表，wx-open-launch-weapp 指H5跳转小程序 wx-open-launch-app 指H5跳转app
        openTagList: ['wx-open-launch-weapp']
      })
      wx.ready(function() {
        // _this.$toast('ready')
        var btn = document.getElementById('launch-btn')
        // launch 用户点击跳转按钮并对确认弹窗进行操作后触发
        btn.addEventListener('launch', function(e) {
          console.log(e, 'success')
        })
        // error 用户点击跳转按钮后出现错误
        btn.addEventListener('error', function(e) {
          console.log(e.detail, 'fail')
          // _this.$toast('click 错误 = ' + e.detail)
        })
      })
      wx.error(function(res) {
        console.log(res, 'error')
        // _this.$toast('错误 = ' + res)
      })
    },
    // 打开事件
    openMiniFunction(val) {
      if (val === 3) {
        this.$toast('请用个人微信打开~')
      } else if (val === 2) {
        // h5
        window.location.href = this.openWithSchemeUrl
      }
      // else if (val === 1) {
      //   // 微信内 h5
      // }
    }
  }
}
document.addEventListener('click', function() {
  // console.log(document.getElementsByClassName('more_box')[0].style.display)
  if (document.getElementsByClassName('more_box')[0].style.display == 'block') {
    // console.log(11111)
    document.getElementsByClassName('more_box')[0].style.display = 'none'
  }
})
</script>
<style scoped lang="scss">
.fontw600{
  font-weight: 600 !important;
}
.pdl72{
  padding-left: 72px !important;
}
.red{
  color: #ee2e2e;
}
.icon_img{
  width: 30px;
  margin-right: 10px;
}
.free_img{
  margin-left: 10px;
  width: 40px;
}
.titleColorGray .typeTitleBlack{
  color: #999 !important;
}
// $openminiHeight:90 + 'px';
// $bg-color: red;

.goTop {
  position: fixed;
  bottom: 120px;
  right: 20px;
  z-index: 1000;
  img {
    width: 120px;
    height: 120px;
    display: block;
    margin: 0px 0 0 0;
  }
}
.qacontent /deep/ img {
  width: 60px;
  height: 60px;
}
.QaDiv {
  display: flex;
  width: 100%;
  margin: 40px 0 0 0;
  padding-bottom: 20px;
  .QaDivleft img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    margin: 0 0 0 30px;
  }
  .QaDivright {
    margin: 0 0 0 16px;
    .qaname {
      color: #999;
      font-size: 26px;
      font-weight: 600;
    }
    .qaextra {
      padding: 12px 0 0 0;
      color: #999;
      font-size: 26px;
    }
    .qacontent {
      color: #333;
      padding: 12px 0 0 0;
      width: 588px;
      font-size: 30px;
    }
    .qatime {
      color: #999;
      padding: 12px 0 0 0;
      font-size: 26px;
    }
    .qareply {
      color: #999;
      padding: 12px 0 0 0;
      font-size: 26px;
    }
  }
}
.ImgBox {
  position: absolute;
  top: 0;
  z-index: 9999;
}
.hfP {
  width: 94%;
  background-color: #f6f6f6;
  // height: 50px;
  min-height: 40px;
  padding: 8px;
  display: flex;
  align-items: center;
  margin-top: 30px;
  .hfPTop {
    width: 125px;
    height: 100%;
    display: flex;
    img {
      margin-left: 10px;
      margin-top: 1px;
      width: 30px !important;
      height: 30px !important;
    }
    .teacher {
      margin-left: 10px;
      height: 40px;
      line-height: 40px;
      width: 75px;
      color: #ee2e2e;
    }
  }
  .t_content {
    width: calc(100% - 130px);
    margin-left: 5px;
    color: #333;
    text-align: left;
  }
}
.mytab_content {
  width: 57%;
  height: 90px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  line-height: 90px;
  .redBottom {
    width: 75px;
    border-bottom: 5px solid #ee2e2e;
    text-align: center;
  }
  p {
    width: 75px;
    text-align: center;
    span {
      font-size: 28px;
      color: #333;
    }
  }
}
.mytab {
  width: 100%;
  height: 90px;
  border-bottom: 2px solid #dfdfdf;
  background: #fff;
}
/deep/ .van-image__img {
  margin-top: 2px;
}
.myThumb {
  height: 562px;
}
.fixedTop {
  position: fixed !important;
  top: 0px !important;
  /deep/.van-icon {
    color: #000 !important;
  }
}
.fixedTop.left-arrow {
  top: 0px !important;
}
.fixedTop.share_btn {
  top: 0px !important;
  right: 0;
}
.fixedTop1 {
  position: fixed !important;
  top: 90px !important;
  /deep/.van-icon {
    color: #000 !important;
  }
}
.fixedTop1.left-arrow {
  top: 90px !important;
}
.fixedTop1.share_btn {
  top: 90px !important;
  right: 0;
}
.popup_div {
  width: 100%;
  height: 100%;
  position: relative;
}
.popup_btn {
  width: 100%;
  height: 96px;
  background: #ee2e2e;
  line-height: 96px;
  color: #fff;
  text-align: center;
  font-size: 35px;
  position: absolute;
  bottom: 0;
}
.popup_btn_gray {
  width: 100%;
  height: 96px;
  background: #e5e5e5;
  line-height: 96px;
  color: #fff;
  text-align: center;
  font-size: 35px;
  // position: absolute;
  // bottom: 0;
}
.span_complet {
  display: inline-block;
  width: 120px;
  text-align: right;
  font-size: 24px;
}
// /deep/ .van-toast{
//   width: 590px !important;
//   height: 230px !important;
// }
.p_span {
  width: 100%;
  height: calc(100% - 420px);
  padding: 20px 0;
  overflow-y: scroll;
  .span1 {
    display: inline-block;
    border: 2px solid #ee2e2e;
    background: #f9edeb;
    padding: 5px 15px;
    border-radius: 25px;
    margin: 20px 0 10px 23px;
    color: #ee2e2e;
  }
  span {
    display: inline-block;
    border: 2px solid #f4f4f4;
    background: #f4f4f4;
    padding: 7px 15px;
    border-radius: 25px;
    margin: 20px 0 10px 23px;
    color: #111;
  }
}
.kongzt {
  width: 100%;
  img {
    width: 150px;
    height: 150px;
    margin: 0 auto;
    display: block;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  p {
    font-size: 28px;
    // font-weight: 600;
    padding-bottom: 20px;
    color: #999;
    text-align: center;
    // padding-top: 30px;
  }
}
.assess {
  margin: 23px 21px 200px 19px;
  font-size: 26px;
  // padding-bottom: 800px;
  padding-bottom: 180px;
  .assess-msg {
    width: 100%;
    margin-top: 20px;
    border-bottom: #f8f8f8 2px solid;
    min-height: 185px;
    display: flex;
    justify-content: space-between;
    .nick {
      padding: 0 13px 20px;
      width: 100%;
      display: flex;
      .nick-img {
        width: 80px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .nick-name {
        display: flex;
        flex-direction: column;
        margin-left: 11px;
        width: 88%;
        font-size: 28px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.p_title {
  font-weight: 600;
  font-size: 30px;
  padding: 5px 0 0 25px;
}
.popup_dl {
  display: flex;
  p {
    padding: 150px 0 0 20px;
    font-weight: 600;
    font-size: 40px;
    color: #ee2e2e;
  }
}
.popup_img {
  width: 240px;
  height: 179px;
  background: #ee2e2e;
  margin: 32px 0 0 26px;
}
.baitTitle {
  width: calc(100% - 180px);
  color: #969799;
  font-size: 30px;
  line-height: 90px;
  padding: 0 0 0 51px;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.videoCount {
  position: absolute;
  right: 30px;
  top: 15px;
  min-width: 36px;
  max-width: 100px;
  height: 36px;
  line-height: 38px;
  background: #ef2d2e;
  border-radius: 18px;
  color: #fff;
  text-align: center;
  padding: 2px 1px 0 1px;
}
.vipzk {
  // width: 110px;
  padding: 0 20px;
  height: 48px;
  font-size: 28px;
  // border: 2px solid #a53c30;
  border-radius: 8px;
  text-align: center;
  line-height: 52px;
  color: #ee2e2e;
  padding: 0 20px;
  letter-spacing: 1px;
  margin-top: 22px;
  margin-right: 20px;
  background: #faeae9;
}
.vipzk1 {
  font-size: 26px;
  width: 130px;
  height: 36px;
  border: 2px solid #ee2e2e;
  border-radius: 30px;
  text-align: center;
  line-height: 40px;
  color: #ee2e2e;
  padding: 2px 5px;
  letter-spacing: 1px;
  margin: 24px 0 0 50px;
}
.vipzk2 {
  font-size: 24px;
  height: 30px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  color: #b56d29;
  padding-top: 4px;
  letter-spacing: 2px;
  margin: 28px 0 0 50px;
}
.zhekTitle {
  flex-shrink: 0;
  font-size: 30px;
  line-height: 92px;
  color: #323233;
  padding-left: 32px;
  overflow: hidden;
}
.zhek {
  height: 95px;
  width: 100%;
  display: flex;
  // background: antiquewhite;
}
.zhekItem{
  margin-left: 46px;
  width: calc(100vw - 60px);
  display: flex;
  justify-content: space-between;
  .zhekLeft{
    display: flex;
  }
  .upgradeVip{
    display: flex;
    align-items: center;
    height: 48px;
    font-size: 28px;
    border-radius: 30px;
    text-align: center;
    line-height: 52px;
    color: #fff;
    background: #ee2e2e;;
    padding: 2px 20px;
    letter-spacing: 1px;
    margin: 24px 20px 0 50px;
    .arrowRight{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 8px;
      font-size: 20px;
      width: 30px;
      height: 30px;
      text-align: center;
      background: #fff;
      color: #ee2e2e;
      border-radius: 50%;
      font-weight: 600;

    }
  }
}
.shareFoot {
  width: 100%;
  height: 84px;
  border-top: 1px solid #f6f6f6;
  position: absolute;
  bottom: 0;
  p {
    text-align: center;
    font-size: 30px;
    line-height: 84px;
  }
}
.qq {
  width: 84px;
  height: 84px;
}
.qqMsg {
  text-align: center;
}
.shareTop {
  width: 100%;
  height: 105px;
  p {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
    text-align: center;
    line-height: 105px;
  }
}
.shareImg {
  width: 100%;
  height: 125px;
}
.shareImgMain {
  width: 348px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.gTille {
  font-size: 24px;
  padding: 15px 10px 5px 11px;
  color: #3e3e3e;
}
.gridImg {
  transform: scale(0.75);
}
.evaluate {
  padding: 25px 0 0 21px;
  font-size: 30px;
  span {
    padding-left: 7px;
  }
}
.Praise_rate {
  padding: 25px 30px 0 0;
  font-size: 30px;
  span {
    padding-left: 7px;
  }
}
.detail-header {
  position: relative;
  height: 100vh;
  .pic {
    width: 100%;
    position: relative;
    img {
      width: 100px;
    }
    .icon {
      display: flex;
      justify-content: space-between;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      z-index: 1000;

      span.left-arrow {
        padding: 20px 0 0 10px;
        flex: 1;
      }
      span.share_btn {
        padding: 17px 10px 0 0;
      }
      .share_tips {
        width: 203px;
        height: 45px;
        position: absolute;
        top: 40px;
        right: 75px;
      }
      .share_tips1 {
        position: absolute;
        top: 0px;
        z-index: -5;
        right: 75px;
        width: calc(100% - 150px);
      }
    }
    img {
      width: 750px;
    }
  }
  /deep/.van-tab .van-tab__text {
    font-size: 28px;
    color: #333;
    margin-top: 2px;
  }
  .detail-title {
    margin-top: 45px;
    margin-bottom: 35px;
    font-size: 34px;
    font-weight: bold;
    color: #333;
  }
  .test_study {
    width: 141px;
    height: 48px;
    line-height: 48px;
    border-radius: 28px;
    font-size: 24px;
    background-color: #ef2d2e;
    color: #fff;
  }
  .detail-study {
    margin-bottom: 26px;
    display: flex;
    justify-content: start;
    .study {
      // position: absolute;
      // top: -3px;
      // left: 40px;
      font-size: 24px;
      letter-spacing: 1px;
      color: #333;
    }
    // .flw {
    //   position: absolute;
    //   top: -3px;
    //   left: 150px;
    // }
    .goods {
      // position: absolute;
      // top: -3px;
      // left: 190px;
      font-size: 24px;
      letter-spacing: 2px;
      color: #333;
    }
    .student_icon {
      width: 28px;
    }
    .Praise {
      width: 24px;
    }
  }
}
.class-detail {
  margin-left: 30px;
}
// 申请试学
.btn-group {
  display: flex !important;
  margin-left: 20px;
  margin-bottom: 19px;
  button {
    background-color: #ef2d2e;
    color: #fff;
  }
}
.border-bgc {
  width: 100vw;
  height: 19px;
  background-color: #f8f8f8;
  // margin-top:19px;
}
.assess-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 55px;
  margin-left: 10px;
  p:last-child {
    color: #adadad;
  }
}
.zl-plan {
  width: 100%;
  height: 90px;
  padding-left: 22px;
  line-height: 90px;
  color: #90c7ae;
  background: #e3f7f0;
}
.iv_sc11 {
  width: 40px;
  height: 40px;
  position: relative;
  top: 4px;
}
.detail-footer {
  position: fixed;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  bottom: 0;
  width: 100%;
  height: 97px;
  background-color: #fff;
  // padding-bottom: 40px;
  .foot-left {
    display: flex;
    align-items: center;
    width: 50%;
    height: 97px;
    border-top: 1px solid #e5e5e5;
    font-size: 22px;
    .left-advice {
      margin: 12px 59px;
      text-align: center;
    }
    .right-like {
      .iv_sc {
        height: 34px;
        width: 34px;
        color: #000;
        margin-top: 8px;
      }
      .tv_sc {
        margin-bottom: 5px;
      }
      text-align: center;
    }
  }
  .footer-right {
    width: 25%;
    height: 98px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: #ef2d2e;
    font-size: 28px;
  }
  .group_work {
    background: linear-gradient(to right, #ff915a 0%, #ff3636 100%);
  }
}
/deep/ .van-tabs__wrap {
  background: #fff;
  border-bottom: 1px solid #dfdfdf;
  border-top: 1px solid #f7f7f7;
  margin-bottom: 10 0 13px auto;
  padding: 0 120px;
  position: relative;
  z-index: 999;
}
// 我要评价
.comment {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 97px;
  background-color: #ef2d2e;
  color: #fff;
  font-size: 28px;
}
// 课表
/deep/ .van-collapse-item__content {
  padding: 0 16px;
}
/deep/ .van-collapse-item__content {
  padding-top: 0;
  // border-bottom:0;
}
.lesson_box {
  padding-top: 90px;
  height: calc(100vh - 180px);
  overflow-y: scroll;
}
.lesson_box1 {
  padding-top: 90px;
  height: calc(100vh - 180px);
  overflow-y: scroll;
}
/deep/ .van-cell {
  padding: 25px 32px;
}
/deep/ .van-cell__title {
  color: #333;
  font-size: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item_course {
  display: flex;
  align-items: center;
  height: 80px;
  border-bottom: 1px solid #ebedf0 !important;
  padding: 12px 20px 13px;
  margin-top: 2px;
}
.item_course:nth-last-child(1) {
  border-bottom: none;
}
.play {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .play_left {
    display: flex;
    width: 100%;
    // align-items: center;
    justify-content: flex-start;
    .video_info {
      font-size: 22px;
      width: 100%;
      align-items: center;
      .span_right {
        display: inline-block;
        width: 100%;
        text-align: right;
        padding-top: 8px;
      }
      p {
        text-align: right;
        span {
          display: inline;
          text-align: right;
        }
      }
    }
    /deep/.van-image {
      width: 30px !important;
      height: 30px !important;
    }
    .video_name {
      font-size: 24px;
      padding-top: 8px;
      width: 100%;
      margin-left: 12px;
      flex-direction: column;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .item_title_box {
        width: 100%;
        display: flex;
        align-items: center;
        line-height: 1;
        .live_btn_ing {
          display: flex;
          align-items: center;
          border: 1px solid #ee2e2e;
          margin-left: 8px;
          font-size: 12px;
          background: #fff;
          color: #ee2e2e;
          padding: 2px 20px;
          border-radius: 20px;
        }
        .live_btn {
          display: flex;
          align-items: center;
          border: 1px solid #969799;
          margin-left: 8px;
          font-size: 12px;
          background: #969799;
          color: #ee2e2e;
          padding: 2px 20px;
          border-radius: 20px;
        }
      }
      .item_title {
        display: inline-block;
        height: 30px;
        line-height: 30px;
        width: 100%;
        // max-width:80%;
        padding-left: 6px;
        overflow: hidden;
        font-size: 26px;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #000;
      }
      .title_gray {
        display: inline-block;
        max-width: 80%;
        font-size: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #969799;
        padding: 0px 0 0 0;
      }
      .item_title_zy {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .learn {
        margin-left: 4px;
        font-size: 18px;
        background: #ee2e2e;
        color: #fff;
        padding: 4px 20px;
        border-radius: 20px;
      }
      img {
        width: 40px;
        height: 40px;
        margin-right: 8px;
      }
    }
    /deep/.van-image__img {
      padding-top: 4px;
      width: 26px;
      height: 26px;
    }
  }
  .common_left {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    img {
      width: 56px;
      height: 56px;
    }
    .video_name {
      width: 100%;
      display: flex;
      font-size: 14px;
      flex-direction: row;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .item_title_box {
        width: 100%;
        display: flex;
        font-size: 14px;
        align-items: center;
      }
      .item_title {
        display: inline-block;
        // max-width:80%;
        font-size: 14px;
        overflow: hidden;
        padding-left: 6px;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #000;
        span {
          font-size: 24px;
          display: inline-block;
          padding-left: 6px;
        }
      }
      .title_gray {
        display: inline-block;
        max-width: 80%;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #969799;
      }
      .item_title_zy {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .learn {
        margin-left: 4px;
        font-size: 12px;
        background: #ee2e2e;
        color: #fff;
        padding: 0 20px;
        border-radius: 20px;
      }
      img {
        width: 40px;
        height: 40px;
        margin-right: 8px;
      }
    }
  }
  .play_right /deep/ .van-icon {
    font-size: 60px;
    transform: rotate(180deg) !important;
  }
}
.detal-tab /deep/ .van-tabs__content {
  padding-bottom: 100px;
}
.size_small {
  font-size: 22px;
  display: inline-block;
}
.zs_span {
  font-size: 24px;
}
#slider {
  // height: 2000px;
  height: calc(100vh - 190px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.nodatas {
  margin-top: 50px;
  margin-bottom: 50px;
  text-align: center;
  img {
    width: 150px;
    height: 150px;
  }
  p {
    color: #999;
    font-size: 26px;
    margin-top: 20px;
  }
}
// 详情
.lesson-info /deep/ img {
  display: block;
  width: 100% !important;
  min-height: 100%;
  -webkit-user-drag: none;
}
.lesson-info {
  position: relative;
  margin-bottom: 250px;
  // font-size:0;
  p {
    margin: 0;
    padding: 0;
  }
}
// 试卷弹窗
.mask {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  .maskBox {
    padding: 20px 0;
    padding-bottom: 60px;
    margin-left: 40px;
    width: calc(100% - 80px);
    background-color: #fff;
    border-radius: 10px;
    .close {
      height: 44px;
      img {
        margin-right: 20px;
        width: 44px;
        height: 44px;
        float: right;
      }
    }
    .title {
      margin-top: 10px;
      padding: 20px 30px;
      width: calc(100% - 60px);
      border-bottom: 1px solid #eee;
      font-size: 28px;
      .imgs {
        display: inline-block;
        vertical-align: middle;
        img {
          width: 30px;
          height: 34px;
        }
      }
      .infos {
        margin-left: 20px;
        display: inline-block;
      }
    }
    .testMsg {
      margin-top: 70px;
      display: flex;
      justify-content: space-around;
      .redWord {
        color: #ee2e2e;
        font-size: 40px;
      }
      .testItem {
        color: #999;
        display: inline-block;
      }
      .line {
        width: 2px;
        height: 44px;
        background: #ddd;
      }
    }
    .btn {
      margin: 80px 30px 0;
      width: calc(100% - 60px);
      height: 88px;
      text-align: center;
      line-height: 88px;
      background: #ee2e2e;
      color: #fff;
      font-size: 28px;
      border-radius: 10px;
    }
    .un_btn {
      background: #999;
    }
  }
  .join_box {
    height: 400px;
  }
  .join_p {
    line-height: 50px;
    margin-top: 50px;
    text-align: center;
  }
}
/deep/ .van-tabs__line {
  background-color: #ee2e2e;
  height: 4px;
}
.class_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #f9f9f9;
  // justify-content: flex-end;
  padding: 20px 15px;
  height: 60px;
  border-bottom: 1px solid #ddd;
  .btns {
    margin-right: 80px;
    display: block;
    .red_btn_st_ct {
      display: flex;
      align-items: center;
      background: #ee2e2e;
      color: #fff;
      font-size: 26px;
      padding: 8px 20px;
      border-radius: 26px;
     
    }
    
    .down_btn {
      width: 172px;
      height: 50px;
      display: block;
      img {
        width: 172px;
        height: 50px;
      }
    }
  }
  .btns:nth-last-child(1){
    margin-right: 0;
  }
  // .tryToLearn {
  //   font-size: 20px;
  //   display: flex;
  //   align-items: center;
  //   margin-right: 30px;
  //   .sqsx {
  //     width: 32px;
  //     margin-right: 8px;
  //   }
  //   .jxxx {
  //     width: 22px;
  //     margin-right: 8px;
  //   }
  //   span {
  //     font-size: 30px;
  //     color: #333;
  //   }
  // }
  .downloadIcon {
    margin-right: 10px;
    height: 60px;
    width: 210px;
    margin-top: 5px;
    img {
      height: 100%;
      width: 100%;
    }
  }
}
.continue_box{
  .study_on {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 28px;
      margin-right: 15px;
      padding: 20px 15px;
      border-bottom: 2px solid #ddd;
      .video_name{
        font-size: 30px;
        width: 480px;
        text-overflow: ellipsis; /* 溢出显示省略号 */
        overflow: hidden; /* 溢出隐藏 */
        white-space: nowrap;  /* 强制不换行 */
      }
    }
}
/deep/.van-image {
  display: block;
}
/deep/.van-tab {
  font-size: 30px;
}
.noChildren /deep/.van-cell__right-icon {
  display: none;
}
.noChildren /deep/.van-collapse-item__wrapper {
  display: none;
}

// 树形结构列表样式
.myTree {
  padding: 10px 20px 30px;
  // background-color: red;
  background-color: #fff;
  /deep/.el-tree-node__content {
    background-color: #fff;
    // padding: 30px 0;
    align-items: flex-start;
    height: auto !important;
    // border-bottom: 1px solid #ddd;
  }
  /deep/.el-tree-node__content > .el-tree-node__expand-icon {
    padding: 8px 6px;
    margin-right: 10px;
    margin-top: 18px;
    // position: absolute;
    right: 25px;
    color: #999;
    transform: rotate(0deg) scale(1.3);
    // transform: scale(1.3);
  }
  /deep/.el-icon-arrow-right:before{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    font-size: 24px;
    color: #fff;
    font-weight: 600;
    background: #ee2e2e;
    border-radius: 50%;
  }
  /deep/.el-tree-node__expand-icon.expanded {
    // transform: rotate(270deg) scale(1.3);
    transform: rotate(90deg) scale(1.3);
  }
  /deep/.el-tree-node__expand-icon.is-leaf {
    // display: none;
    visibility: hidden;
    // display: none;
    color: transparent;
    cursor: default;
    margin-right: -12px;
  }
  .cellBg{
    background: #f6f6f6 !important;
  }
  .treeCell {
    width: calc(100% - 44px);
    margin-left: -50px;
    // padding-left: 50px;
    padding: 20px 0 20px 50px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    // 章的标题单独处理
    .mainTitleBox{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .exerciseBtn{
        font-size: 24px;
        padding: 1px 12px;
        color: #fff;
        background: #ee2e2e;
        border-radius: 30px;
      }
      .exerciseBtnGray {
        font-family: PingFangSC-Regular;
        text-align: center;
        display: inline-block;
        font-size: 24px;
        padding: 1px 12px;
        color: #999;
        border:2px solid #999;
        border-radius: 30px;
      }
    }
    .treeTitleBox {
      // 和里层的不能删
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      display: flex;
      align-items: center;
      .typeIcon {
        margin-right: 10px;
        width: 30px;
        height: 30px;
      }
      .typeTitle {
        font-family: PingFangSC-Regular;
        // font-weight: 600;
        line-height: 40px;
        font-size: 30px;
        // 和外部的不能删
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .typeTitleRed {
        color: #ee2e2e;
      }
      .typeTitleBlack {
        color: #333;
      }
      .typeTitleGray {
        color: #999;
      }
      .redSpan {
        margin-left: 10px;
        padding: 2px 20px;
        font-family: PingFangSC-Regular;
        text-align: center;
        display: inline-block;
        background-color: #ee2e2e;
        color: #fff;
        font-size: 28px;
        border-radius: 20px;
      }
      .toBeupdaded{
        padding-left: 10px;
        font-size: 24px;
        color: #ee2e2e;
      }
      .important {
        margin-left: 10px;
        font-family: PingFangSC-Regular;
        text-align: center;
        display: inline-block;
        color: #999;
        font-size: 28px;
      }
    }
    .reviewTreeDetailBox{
      width: 100% !important;
      .reviewTreeDetailLeft{
          width:100% !important;
        }
    }
    .treeDetailBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .treeDetailLeft {
        margin-top: 20px;
        font-family: PingFangSC-Regular;
        font-size: 26px;
        color: #999;
        // 视频类型
        .study_info{
          margin-left: 45px;
          display: flex;
          align-items: center;
          .video_progress{
            display: flex;
            align-items: center;
            margin-right: 20px;
            .title_name{
              font-size: 24px;
              margin-right: 10px;
            }
            .controlInfo{
              text-align: center;
              min-width: 100px;
            }
          }
        }
        .outer_review{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .review_btn{
            display: flex;
            align-items: center;
            .treeDetailRight{
              margin-top: 0;
            }
          }
        }
        // 评测得分样式
        .testScore{
          margin-left: 45px;
          display: flex;
          align-items: center;
        }
        .info1 {
          margin-right: 10px;
        }
        .info2 {
          color: #ee2e2e;
          margin-right: 10px;
        }
        .isLiving {
          margin-right: 10px;
          float: right;
          display: flex;
          align-items: center;
          color: #ee2e2e;
          img {
            margin-right: 6px;
            width: 20px;
          }
        }
        .liveNoBegin {
          margin-right: 10px;
          // float: right;
          display: flex;
          align-items: center;
          img {
            margin-right: 6px;
            width: 20px;
          }
        }
      }
      .treeDetailRight {
        margin-top: 25px;
        .exerciseBtn {
          font-family: PingFangSC-Regular;
          text-align: center;
          display: inline-block;
          font-size: 24px;
          padding: 1px 12px;
          color: #fff;
          background: #ee2e2e;
          border:2px solid #ee2e2e;
          border-radius: 30px;
        }
        .exerciseBtnGray {
          font-family: PingFangSC-Regular;
          text-align: center;
          display: inline-block;
          font-size: 24px;
          padding: 1px 12px;
          color: #999;
          border:2px solid #999;
          border-radius: 30px;
        }
        .toTest {
          padding: 5px 15px;
          font-family: PingFangSC-Regular;
          background-color: #ee2e2e;
          text-align: center;
          display: inline-block;
          color: #fff;
          font-size: 28px;
          border-radius: 30px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#nick >>> img {
  width: 20px;
  height: 20px;
}
.zhekTitle-width {
  margin-left: 98px;
}
.st {
  padding: 20px;
  height: 40px;
  border-bottom: 1px solid #ddd;
  text-align: right;
}
.st_btn {
  // float:right;
  background: #ee2e2e;
  color: #fff;
  font-size: 32px;
  padding: 10px 30px;
  border-radius: 26px;
}
.freeTime {
  color: #fff;
  background: #fb7014;
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.successBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 680px;
  height: 800px;
  background: url("../../assets/getSuccess.png") no-repeat;
  background-size: contain;
  // padding-bottom: 50px;
}
/deep/.van-popup  {
  overflow-y: visible !important;
}

.share_pop {
  .top_icon {
    height: 80px;
    margin-left: -20px;
  }
  .mid_box {
    padding: 15px 15px;
    width: 400px;
    margin: 0 auto;
  }
  .bot {
    margin-top: 20px;
    .share_i {
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 80px;
      line-height: 80px;
      font-size: 36px;
      border-top: 2px solid #ddd;
      border-bottom: 2px solid #ddd;
      img {
        width: 60px;
        height: 60px;
        margin-left: 30px;
      }
    }
    .share_i1 {
      text-align: center;
      height: 80px;
      line-height: 80px;
      font-size: 36px;
    }
  }
  .titl {
    font-size: 24px;
    margin: 10px 0;
  }
  .thumb {
    width: 400px;
    height: 300px;
    display: block;
  }
}

.shareBox {
  text-align: center;
  width: calc(100% - 160px);
  border-radius: 12px;
  .iocn1 {
    width: 120px;
    margin: -60px auto;
  }
  .title1 {
    font-size: 44px;
    font-weight: 400;
    margin-top: 80px;
  }
  .title2 {
    font-size: 32px;
    margin-top: 30px;
    margin-bottom: 60px;
  }
  .close_icon {
    width: 70px;
    margin-bottom: -120px;
  }
}

.over {
  opacity: 0.5;
}
.tips {
  font-size: 32px;
  margin-bottom: 20px;
}
.tips2 {
  font-size: 44px;
  font-weight: 600;
  margin-bottom: 40px;
  margin-top: 200px;
}
.seeMore{
  margin-top:30px;
  text-align: center;
  font-size: 30px;
  color: #adadad;
}
.header-wrap{
  height:100%;
  background: #fff;
}

.box-container {
  padding: 10px 0;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  .one_item {
    margin: 10px 0;
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
    .img_icon {
      width: 24px;
      height: 24px;
      display: block;
    }
    .info_text {
      margin-left: 8px;
      color: #333333;
    }
  }
}

.smwy_btn{
  margin: 0 auto 40px;
  width: 710px;
  height: 109px;
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
  align-items: center;
  background: #FDEAEA;
  font-size: 32px;
  .pj-text{
    margin-left: 15px;
    color: #ee2e2e;
  }
  .pj-btn1{
    width: 210px;
    height: 60px;
    line-height: 61px;
    margin-right: 15px;
    border-radius: 50px;
    background-color: rgba(238, 46, 46, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 32px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    font-family: Microsoft Yahei;
  }
}
*{
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
.suo{
  position: absolute;
  padding: 0 0 0 8px;
  right: 25px;
  width: 40px;
}

$openminiHeight: 90px;

.openMpBoxTop {
  width: 100%;
  height: $openminiHeight;
}
.openMpBox {
  background-color: #fff;
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: $openminiHeight;
  z-index: 1100;

  display: flex;
  align-items: center;
  .tipsleft {
    width: 75%;
    height: $openminiHeight;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      margin-right: 10px;
      width: 50px;
      height: 50px;
      display: block;
    }
    .text {
      margin-left: 10px;
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #333;
    }
  }
  .btnright {
    width: 25%;
    height: $openminiHeight;
    line-height: $openminiHeight;
    text-align: center;
    background-color: #ee2e2e;
    box-sizing: border-box;
    overflow: hidden;
    .openbtn {
      background-color: #ee2e2e;
      display: inline-block;
      width: 100%;
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #fff;
    }
  }
}
.origin-price {
  margin-bottom: 20px;
  padding: 0 25px;
  .price {
    color: #ee2e2e;
    font-size: 28px;
    font-weight: 600;
    .big {
      font-size: 38px;
    }
  }
}
</style>

